(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[302],{

/***/ 62667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-MPFPK3CX.mjs
var chunk_MPFPK3CX = __webpack_require__(88828);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-3V5HNFOM.mjs
var chunk_3V5HNFOM = __webpack_require__(91527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/chunk-NO6MRLPK.mjs
var chunk_NO6MRLPK = __webpack_require__(85798);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chunk-CHB4ZXZG.mjs + 5 modules
var chunk_CHB4ZXZG = __webpack_require__(44853);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-6CSUKJP7.mjs
var chunk_6CSUKJP7 = __webpack_require__(62824);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-VRAQ7LO3.mjs
var chunk_VRAQ7LO3 = __webpack_require__(28366);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chunk-7PTKRZFZ.mjs + 1 modules
var chunk_7PTKRZFZ = __webpack_require__(19348);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(99728);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(27427);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-MUMUYFOI.mjs
var chunk_MUMUYFOI = __webpack_require__(96138);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chunk-E77276RR.mjs + 2 modules
var chunk_E77276RR = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/close-button/dist/chunk-DUEJD2BE.mjs
var chunk_DUEJD2BE = __webpack_require__(20540);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(75657);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Layout/NavItem/index.tsx








var NavItem = function(_param) {
    var icon = _param.icon, to = _param.to, children = _param.children, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "to",
        "children"
    ]);
    var router = (0,next_router.useRouter)();
    var isActiveRoute = router.pathname.startsWith(to);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: to,
        style: {
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            align: "center",
            gap: "1rem",
            px: "4",
            py: "3",
            mx: "4",
            cursor: "pointer",
            _hover: {
                bg: "whiteAlpha.100"
            },
            bg: isActiveRoute ? "whiteAlpha.300" : "inherit",
            fontSize: {
                base: 14,
                lg: 16
            }
        }, rest), {
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_E77276RR/* Image */.E, {
                    src: icon,
                    alt: "icon",
                    className: "logo"
                }),
                children
            ]
        }))
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(42299);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-HUQHYERK.mjs
var chunk_HUQHYERK = __webpack_require__(14040);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-P74GIWPW.mjs
var chunk_P74GIWPW = __webpack_require__(24156);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(21157);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var es = __webpack_require__(43795);
;// CONCATENATED MODULE: ./state/domain.ts



var initialDomainEnv = (0,es/* atom */.cn)({
    key: "domainEnv",
    default: {
        isApollo: true,
        isChecking: true
    }
});
var useDomainEnv = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,es/* useRecoilState */.FV)(initialDomainEnv), 2), domainEnv = ref[0], setDomainENV = ref[1];
    (0,react.useEffect)(function() {
        var isArthswap = window.location.hostname === "wasm.arthswap.org";
        setDomainENV({
            isApollo: !isArthswap,
            isChecking: false
        });
    }, [
        setDomainENV
    ]);
    return domainEnv;
};

;// CONCATENATED MODULE: ./components/Layout/SidebarFooter/index.tsx





var DomainEnvs;
(function(DomainEnvs) {
    DomainEnvs["APOLLO"] = "apollo";
    DomainEnvs["ARTHSWAP"] = "arthswap";
})(DomainEnvs || (DomainEnvs = {}));
var _obj;
var LinkItems = (_obj = {}, (0,_define_property/* default */.Z)(_obj, DomainEnvs.APOLLO, [
    {
        name: "twitter",
        icon: "/Twitter.svg",
        to: "https://twitter.com/Apollo_dex"
    },
    {
        name: "Medium",
        icon: "/Medium.svg",
        to: "https://medium.com/@apolloswap"
    },
    {
        name: "discord",
        icon: "/Discord.svg",
        to: "https://discord.gg/3Hq6xUyjw8"
    },
    {
        name: "Faucet",
        icon: "/Github.svg",
        to: "https://github.com/AstarNetwork/wasm-showcase-dapps/tree/main/uniswap-v2"
    }
]), (0,_define_property/* default */.Z)(_obj, DomainEnvs.ARTHSWAP, [
    {
        name: "twitter",
        icon: "/Twitter.svg",
        to: "https://twitter.com/arthswap"
    },
    {
        name: "Medium",
        icon: "/Medium.svg",
        to: "https://medium.com/arthswap"
    },
    {
        name: "discord",
        icon: "/Discord.svg",
        to: "https://discord.gg/GyHZ69rPTK"
    },
    {
        name: "Github",
        icon: "/Github.svg",
        to: "https://github.com/ArthSwap"
    }
]), _obj);
var SidebarFooter = function() {
    var isApollo = useDomainEnv().isApollo;
    var key = isApollo ? DomainEnvs.APOLLO : DomainEnvs.ARTHSWAP;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_6CSUKJP7/* Box */.xu, {
        p: 4,
        fontSize: {
            base: 14,
            lg: 16
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_HUQHYERK/* HStack */.U, {
                mt: "20",
                children: LinkItems[key].map(function(item, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: item.to,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_E77276RR/* Image */.E, {
                            src: item.icon,
                            alt: item.name,
                            className: "logo"
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
                height: "50"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                children: [
                    "\xa9 2023 ",
                    isApollo ? "Apollo Swap" : "Arthswap"
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/env/getEnv.ts
var getEnv = __webpack_require__(36274);
;// CONCATENATED MODULE: ./components/Layout/SidebarContent/index.tsx










var SidebarContent_LinkItems = [
    {
        name: "Swap",
        icon: "/Swap.svg",
        to: "/swap",
        enableOnProd: true
    },
    {
        name: "Pool",
        icon: "/Pool.svg",
        to: "/pool",
        enableOnProd: true
    },
    {
        name: "Farm",
        icon: "/Farm.svg",
        to: "/farm",
        enableOnProd: true
    },
    {
        name: "Faucet",
        icon: "/Swap.svg",
        to: "/faucet",
        enableOnProd: true
    }
];
var SidebarContent = function(_param) {
    var onClose = _param.onClose, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onClose"
    ]);
    var isApollo = useDomainEnv().isApollo;
    var linkItems = getEnv/* isProd */.B ? SidebarContent_LinkItems.filter(function(item) {
        return item.enableOnProd;
    }) : SidebarContent_LinkItems;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        w: {
            base: "full",
            md: "220px"
        },
        pos: "fixed",
        h: "100vh",
        bg: isApollo ? "whiteAlpha.50" : "transparent"
    }, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MUMUYFOI/* VStack */.g, {
            align: "stretch",
            justify: "space-between",
            h: "full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_6CSUKJP7/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
                            h: "20",
                            alignItems: "center",
                            mx: "8",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_E77276RR/* Image */.E, {
                                    src: isApollo ? "/logo_wh.png" : "/arthswap/arthswap_logo.png",
                                    alt: isApollo ? "ApolloSwap" : "Arthswap",
                                    width: "157.3px",
                                    height: "40px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_DUEJD2BE/* CloseButton */.P, {
                                    display: {
                                        base: "flex",
                                        md: "none"
                                    },
                                    onClick: onClose
                                })
                            ]
                        }),
                        linkItems.map(function(link) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                                icon: link.icon,
                                to: link.to,
                                children: link.name
                            }, link.name);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarFooter, {})
            ]
        })
    }));
};

// EXTERNAL MODULE: ./constants/chainIdByName.ts
var chainIdByName = __webpack_require__(15817);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icons/dist/chunk-RGZJAHFA.mjs
var chunk_RGZJAHFA = __webpack_require__(51088);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-6FWJQRCB.mjs
var chunk_6FWJQRCB = __webpack_require__(60480);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-Z6E7Q7NQ.mjs
var chunk_Z6E7Q7NQ = __webpack_require__(78168);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-7SUBCGSP.mjs
var chunk_7SUBCGSP = __webpack_require__(7552);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-NAA7TEES.mjs + 3 modules
var chunk_NAA7TEES = __webpack_require__(53984);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-5DPVNQWT.mjs
var chunk_5DPVNQWT = __webpack_require__(91425);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/chunk-VM7O7UWC.mjs + 3 modules
var chunk_VM7O7UWC = __webpack_require__(89868);
// EXTERNAL MODULE: ./state/wsProvider.ts
var wsProvider = __webpack_require__(49802);
;// CONCATENATED MODULE: ./components/SelectNetwork/index.tsx








var MenuItemTokenImage = function(param) {
    var name = param.name, optionalText = param.optionalText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_E77276RR/* Image */.E, {
                src: "/tokens/".concat(name, ".webp"),
                alt: name,
                boxSize: 5
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6FWJQRCB/* Spacer */.L, {
                ml: 2
            }),
            optionalText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                children: optionalText
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                children: name
            })
        ]
    });
};
var SelectNetwork = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,wsProvider/* useChainIdByProvider */.a$)(), 2), chainId = ref[0], setChainId = ref[1];
    var selectedNetwork = (0,react.useMemo)(function() {
        switch(chainId){
            case chainIdByName/* chainIdByName.shibuya */.T.shibuya:
                return "Shibuya";
            case chainIdByName/* chainIdByName.shiden */.T.shiden:
                return "Shiden";
            default:
                return "Select Network";
        }
    }, [
        chainId
    ]);
    var handleSelectNetwork = function(network) {
        switch(network){
            case "shiden":
                setChainId(chainIdByName/* chainIdByName.shiden */.T.shiden);
                break;
            case "shibuya":
                setChainId(chainIdByName/* chainIdByName.shibuya */.T.shibuya);
                break;
            default:
                setChainId(chainIdByName/* chainIdByName.shibuya */.T.shibuya);
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z6E7Q7NQ/* Menu */.v, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_7SUBCGSP/* MenuButton */.j, {
                as: chunk_NAA7TEES/* Button */.z,
                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_RGZJAHFA/* ChevronDownIcon */.v, {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
                    children: selectedNetwork !== "Select Network" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemTokenImage, {
                        name: selectedNetwork.toLowerCase()
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                        children: selectedNetwork
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_5DPVNQWT/* MenuList */.q, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_VM7O7UWC/* MenuItem */.s, {
                        onClick: function() {
                            return handleSelectNetwork("shibuya");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemTokenImage, {
                            name: "shibuya",
                            optionalText: "Shibuya (testnet)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_VM7O7UWC/* MenuItem */.s, {
                        onClick: function() {
                            return handleSelectNetwork("shiden");
                        },
                        isDisabled: getEnv/* isProd */.B,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemTokenImage, {
                            name: "shiden",
                            optionalText: "Shiden (coming soon..)"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_VM7O7UWC/* MenuItem */.s, {
                        isDisabled: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItemTokenImage, {
                            name: "astar",
                            optionalText: "Astar (coming soon..)"
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-3HSDMH4Y.mjs
var chunk_3HSDMH4Y = __webpack_require__(83948);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(50167);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/chunk-QUJ23J4G.mjs + 1 modules
var chunk_QUJ23J4G = __webpack_require__(50004);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-O5CRURSQ.mjs + 3 modules
var chunk_O5CRURSQ = __webpack_require__(48069);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/chunk-FL4WJEVU.mjs + 2 modules
var chunk_FL4WJEVU = __webpack_require__(12669);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chunk-OLSEFBIG.mjs + 3 modules
var chunk_OLSEFBIG = __webpack_require__(48370);
// EXTERNAL MODULE: ./hooks/polkadotExtension/useAccounts.ts + 1 modules
var useAccounts = __webpack_require__(28037);
;// CONCATENATED MODULE: ./components/Layout/ConnectPolkadotJS/index.tsx




var ConnectPolkadotJS = function() {
    var ref = (0,useAccounts/* useAccounts */.x)(), accounts = ref.accounts, account = ref.account, setAccount = ref.setAccount;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_Z6E7Q7NQ/* Menu */.v, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_7SUBCGSP/* MenuButton */.j, {
                as: chunk_NAA7TEES/* Button */.z,
                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_RGZJAHFA/* ChevronDownIcon */.v, {}),
                bg: "whiteAlpha.200",
                fontSize: {
                    base: 12,
                    lg: 16
                },
                _hover: {
                    bg: "whiteAlpha.200"
                },
                _active: {
                    bg: "whiteAlpha.200"
                },
                children: account ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                    children: [
                        account.meta.name,
                        ": ",
                        account.address.slice(0, 7),
                        "..."
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                    children: "connect wallet"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_5DPVNQWT/* MenuList */.q, {
                bg: "whiteAlpha.200",
                border: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_QUJ23J4G/* RadioGroup */.E, {
                    onChange: function(v) {
                        var anct = accounts === null || accounts === void 0 ? void 0 : accounts.find(function(x) {
                            return x.address === v;
                        });
                        if (anct) {
                            setAccount(anct);
                        }
                    },
                    value: account === null || account === void 0 ? void 0 : account.address,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_O5CRURSQ/* Stack */.K, {
                        children: accounts === null || accounts === void 0 ? void 0 : accounts.map(function(acnt, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_VM7O7UWC/* MenuItem */.s, {
                                bg: "whiteAlpha.200",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_FL4WJEVU/* Radio */.Y, {
                                    value: acnt.address,
                                    checked: acnt.address === (account === null || account === void 0 ? void 0 : account.address),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_OLSEFBIG/* Show */.d, {
                                            above: "lg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                                fontSize: 16,
                                                children: [
                                                    acnt.meta.name,
                                                    ": ",
                                                    acnt.address
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_OLSEFBIG/* Show */.d, {
                                            below: "lg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_P74GIWPW/* Text */.x, {
                                                fontSize: 12,
                                                children: [
                                                    acnt.meta.name,
                                                    ": ",
                                                    acnt.address.slice(0, 15),
                                                    "..."
                                                ]
                                            })
                                        })
                                    ]
                                }, acnt.address)
                            }, i);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Layout/MobileNav/index.tsx









var MobileNav = function(_param) {
    var onOpen = _param.onOpen, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "onOpen"
    ]);
    var isApollo = useDomainEnv().isApollo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_MPFPK3CX/* Flex */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ml: {
            base: 0,
            md: 60
        },
        px: {
            base: 4,
            md: 4
        },
        height: "20",
        alignItems: "center",
        justifyContent: {
            base: "space-between",
            md: "flex-end"
        }
    }, rest), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_3HSDMH4Y/* IconButton */.h, {
                display: {
                    base: "flex",
                    md: "none"
                },
                onClick: onOpen,
                variant: "outline",
                "aria-label": "open menu",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FiMenu */.cur, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_P74GIWPW/* Text */.x, {
                display: {
                    base: "flex",
                    md: "none"
                },
                fontSize: 14,
                fontWeight: "bold",
                children: isApollo ? "Apollo Swap" : "Arthswap"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_HUQHYERK/* HStack */.U, {
                spacing: {
                    base: "0",
                    md: "6"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectNetwork, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectPolkadotJS, {})
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(1984);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(78703);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/Layout/ArthswapHead.tsx



var ArthswapHead = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "shortcut icon",
                        type: "image/png",
                        href: "/arthswap/favicon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "192x192",
                        href: "/arthswap/192x192_App_Icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "512x512",
                        href: "/arthswap/512x512_App_Icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "manifest",
                        href: "/arthswap/manifest.json"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "ArthSwap | the No.1 one-stop DeFi / DEX on Astar Network"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "ArthSwap is the No.1 decentralized exchange with the largest community on Astar Network. It has very high APY and simple UI, quite easy to use."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "theme-color",
                        content: "#000000"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "fortmatic-site-verification",
                        content: "j93LgcVZk79qcgyo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "initial-scale=1, maximum-scale=3, minimum-scale=1, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "/arthswap/arthswap.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "ArthSwap is the No.1 decentralized exchange with the largest community on Astar Network. It has very high APY and simple UI, quite easy to use."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "ArthSwap is the No.1 decentralized exchange with the largest community on Astar Network. It has very high APY and simple UI, quite easy to use."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "google-tag-manager",
                children: ";(function(w, d, s, l, i) {\n        w[l] = w[l] || []\n        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })\n        var f = d.getElementsByTagName(s)[0],\n          j = d.createElement(s),\n          dl = l != 'dataLayer' ? '&l=' + l : ''\n        j.async = true\n        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl\n        f.parentNode.insertBefore(j, f)\n      })(window, document, 'script', 'dataLayer', '%REACT_APP_GTAG%')"
            })
        ]
    });
};
/* harmony default export */ var Layout_ArthswapHead = (ArthswapHead);

;// CONCATENATED MODULE: ./components/Layout/Sidebar.tsx







var Sidebar = function(param) {
    var children = param.children;
    var ref = (0,chunk_CHB4ZXZG/* useDisclosure */.q)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var ref1 = useDomainEnv(), isApollo = ref1.isApollo, isChecking = ref1.isChecking;
    if (isChecking) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isApollo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_ArthswapHead, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chunk_6CSUKJP7/* Box */.xu, {
                minH: "100vh",
                bg: !isApollo ? "url('/arthswap/arthswap_bg.png')" : "none",
                bgSize: "cover",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarContent, {
                        onClose: function() {
                            return onClose;
                        },
                        display: {
                            base: "none",
                            md: "block"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_VRAQ7LO3/* Drawer */.d, {
                        autoFocus: false,
                        isOpen: isOpen,
                        placement: "left",
                        onClose: onClose,
                        returnFocusOnClose: false,
                        onOverlayClick: onClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_7PTKRZFZ/* DrawerContent */.s, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SidebarContent, {
                                onClose: onClose
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNav, {
                        onOpen: onOpen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_6CSUKJP7/* Box */.xu, {
                        ml: {
                            base: 0,
                            md: 60
                        },
                        p: "4",
                        px: "2",
                        children: children
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/Layout/index.tsx





var Layout = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    (0,react.useEffect)(function() {
        var handleStart = function(url) {
            return url !== router.asPath && setLoading(true);
        };
        var handleComplete = function(url) {
            return url === router.asPath && setLoading(false);
        };
        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleComplete);
        router.events.on("routeChangeError", handleComplete);
        return function() {
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleComplete);
            router.events.off("routeChangeError", handleComplete);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Sidebar, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
            justifyContent: "center",
            direction: {
                base: "column",
                sm: "row"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_MPFPK3CX/* Flex */.k, {
                direction: "column",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_3V5HNFOM/* Center */.M, {
                    w: "100%",
                    minH: 500,
                    children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chunk_NO6MRLPK/* Spinner */.$, {
                        size: "lg"
                    }) : children
                })
            })
        })
    });
};


/***/ }),

/***/ 78732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ TokenImage; }
/* harmony export */ });
/* unused harmony export tokenImage */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5447);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27427);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _hooks_useApi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1544);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57922);





var tokenImage = function(chainId, address) {
    return "/tokens/".concat(chainId, "/").concat(address, ".png");
};
var TokenImage = function(_param) {
    var address = _param.address, ml = _param.ml, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "address",
        "ml"
    ]);
    var chainID = (0,_hooks_useApi__WEBPACK_IMPORTED_MODULE_1__/* .useChainId */ .xx)();
    if (!chainID) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: tokenImage(chainID, address),
        alt: address.substring(0, 2),
        boxSize: "32px",
        ml: ml ? ml : 0
    }, rest));
};


/***/ }),

/***/ 80472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TV": function() { return /* binding */ tokens; },
/* harmony export */   "V3": function() { return /* binding */ createToken; },
/* harmony export */   "hz": function() { return /* binding */ lpTokens; }
/* harmony export */ });
/* unused harmony export rewardTokens */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5447);
/* harmony import */ var _shibuya__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72623);
/* harmony import */ var _shiden__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52004);



var tokens = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _shibuya__WEBPACK_IMPORTED_MODULE_0__/* .shibuyaTokens */ .B2, _shiden__WEBPACK_IMPORTED_MODULE_1__/* .shidenTokens */ .st);
var lpTokens = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _shibuya__WEBPACK_IMPORTED_MODULE_0__/* .shibuyaLPTokens */ ._9, _shiden__WEBPACK_IMPORTED_MODULE_1__/* .shidenLPTokens */ .jZ);
var rewardTokens = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _shibuya__WEBPACK_IMPORTED_MODULE_0__/* .shibuyaRewardTokens */ .On, _shiden__WEBPACK_IMPORTED_MODULE_1__/* .shidenRewardTokens */ .A2);
var createToken = function(address, symbol, decimal) {
    return {
        address: address,
        symbol: symbol,
        name: symbol,
        decimal: decimal,
        chainId: 0,
        isNative: false
    };
};


/***/ }),

/***/ 72623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B2": function() { return /* binding */ shibuyaTokens; },
/* harmony export */   "B8": function() { return /* binding */ SHIBUYA_TOKENS_BY_SYMBOL; },
/* harmony export */   "On": function() { return /* binding */ shibuyaRewardTokens; },
/* harmony export */   "_9": function() { return /* binding */ shibuyaLPTokens; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42299);
/* harmony import */ var _chainIdByName__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15817);


var SHIBUYA_TOKENS_BY_SYMBOL = {
    ASTAR: {
        address: "5C4hrfjw9DjXZTzV3MwzrrAr9P1MJhSrvWGWqi1eSuyUpnhM",
        symbol: "ASTR",
        name: "Astar",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya,
        isNative: true
    },
    wASTAR: {
        address: "ZCp71ZzxnEc7KcycQUdQv5VYNZMqnApKQsh1hwG2DTeEF1T",
        symbol: "wASTR",
        name: "wAstar",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya,
        isWrapped: true
    },
    APLO: {
        address: "Yd2Z4Wri1uWMVPLxY5m3UDg7cejuornj7waJXi7Sq9cyMhC",
        symbol: "APLO",
        name: "Apollo",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    USDC: {
        address: "YTcCssfLFyZpyHc3seFrj8vqJsuLw3B5NrGRQVdq2Yw7Ber",
        symbol: "USDC",
        name: "USDC",
        decimal: 6,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    USDT: {
        address: "Wmiq6wtgomqBPhr1Vr4P61PR4JhhHfV15sQrqJZu94ww8vz",
        symbol: "USDT",
        name: "USDT",
        decimal: 6,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    }
};
var shibuyaTokens = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya, [
    {
        address: "5C4hrfjw9DjXZTzV3MwzrrAr9P1MJhSrvWGWqi1eSuyUpnhM",
        symbol: "ASTR",
        name: "Astar",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya,
        isNative: true
    },
    {
        address: "ZCp71ZzxnEc7KcycQUdQv5VYNZMqnApKQsh1hwG2DTeEF1T",
        symbol: "wASTR",
        name: "wAstar",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya,
        isWrapped: true
    },
    {
        address: "Yd2Z4Wri1uWMVPLxY5m3UDg7cejuornj7waJXi7Sq9cyMhC",
        symbol: "APLO",
        name: "Apollo",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "YTcCssfLFyZpyHc3seFrj8vqJsuLw3B5NrGRQVdq2Yw7Ber",
        symbol: "USDC",
        name: "USDC",
        decimal: 6,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "Wmiq6wtgomqBPhr1Vr4P61PR4JhhHfV15sQrqJZu94ww8vz",
        symbol: "USDT",
        name: "USDT",
        decimal: 6,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    }
]);
var shibuyaLPTokens = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya, [
    {
        address: "Z6QTdZubAm8SA71XJb1x415e9Q9PtuGcTsgZ4WaVPnhZBUk",
        symbol: "APLO/SBY",
        name: "APLO/SBY-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "bVZHeY66R45uVm4mi1Y9JBV719YBb7dsyKk1z6m4sWQ57C3",
        symbol: "USDC/SBY",
        name: "USDC/SBY-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "YNcB5F4p6MbGwQyoUfysmDKD2GWsnp6YjBB73mBB2mG5HjH",
        symbol: "USDT/SBY",
        name: "USDT/SBY-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "aBNQSpNjNcRwT6EKiV7Q9n845DuDW2ZthxZQ6DbXghKy41w",
        symbol: "USDT/USDC",
        name: "USDT/USDC-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "XnZrYMMvJHfrsnYVVt6C9GUpqfNLhazG5CbUt7bVp6yeFhB",
        symbol: "USDT/APLO",
        name: "USDT/APLO-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    },
    {
        address: "WBRFed3pKnqHfHCgmhMnbekGSRjokDy4CkEEA45duEKsnF5",
        symbol: "USDC/APLO",
        name: "USDC/APLO-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    }
]);
var shibuyaRewardTokens = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya, [
    {
        address: "aUVz39CCarmJViLBRvuMHUgJyQHqqGwnKLutTCUZqNrWGfX",
        symbol: "APLO",
        name: "APLO",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shibuya */ .T.shibuya
    }
]);


/***/ }),

/***/ 52004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A2": function() { return /* binding */ shidenRewardTokens; },
/* harmony export */   "jZ": function() { return /* binding */ shidenLPTokens; },
/* harmony export */   "ne": function() { return /* binding */ SHIDEN_TOKENS_BY_SYMBOL; },
/* harmony export */   "st": function() { return /* binding */ shidenTokens; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42299);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84911);
/* harmony import */ var _chainIdByName__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15817);



var SHIDEN_TOKENS_BY_SYMBOL = {
    ASTAR: {
        address: "5C4hrfjw9DjXZTzV3MwzrrAr9P1MJhSrvWGWqi1eSuyUpnhM",
        symbol: "SDN",
        name: "SDN",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden,
        isNative: true
    },
    wSDN: {
        address: "ZSDrDTGMNimo22YHpzs49fzG4GcerPrpYQzoEtpySrtSRpo",
        symbol: "wSDN",
        name: "wSDN",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden,
        isWrapped: true
    },
    APLO: {
        address: "b8fqotA8AckKtR6wfmE7QYZ6y5w8Hsh1MN2wAuXEQ1jbfVu",
        symbol: "APLO",
        name: "Apollo",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden
    },
    USDC: {
        address: "Z7NpKVgBavzEQRRNyNmHi5U1BBZjLH1XpJydao8vFH4K8xn",
        symbol: "USDC",
        name: "USDC",
        decimal: 6,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden
    },
    USDT: {
        address: "XCpKjSRxEbAS8LDcQZ7ywAmrcUjqaimbi24q3mwAhcthfJq",
        symbol: "USDT",
        name: "USDT",
        decimal: 6,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden
    }
};
var shidenTokens = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Object.values(SHIDEN_TOKENS_BY_SYMBOL)));
var shidenLPTokens = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden, [
    {
        address: "ZecCT7BaZrXYxZrPJypNq3A57PnQACZJwzjPnG9iyPmUe5s",
        symbol: "APLO/SDY",
        name: "APLO/SDY-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden
    },
    {
        address: "ayNfpxDUZazkrkXhexvKTW6BHBquUztEEZJRH9qT7hrJtyc",
        symbol: "USDC/SDY",
        name: "USDC/SDY-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden
    },
    {
        address: "WPmuWw7EAdHZM8GvEAvYVFdgRyFj7FY3jcMLRgBB9SeuWtj",
        symbol: "USDT/SDY",
        name: "USDT/SDY-LP",
        decimal: 18,
        chainId: _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden
    }
]);
var shidenRewardTokens = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _chainIdByName__WEBPACK_IMPORTED_MODULE_0__/* .chainIdByName.shiden */ .T.shiden, [
    SHIDEN_TOKENS_BY_SYMBOL.APLO
]);


/***/ }),

/***/ 78669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useAllTokens; }
/* harmony export */ });
/* harmony import */ var _useApi__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1544);
/* harmony import */ var _constants_tokens__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80472);


var useAllTokens = function() {
    var chainId = (0,_useApi__WEBPACK_IMPORTED_MODULE_0__/* .useChainId */ .xx)();
    if (!chainId) {
        return [];
    }
    return _constants_tokens__WEBPACK_IMPORTED_MODULE_1__/* .tokens */ .TV[chainId] || [];
};


/***/ }),

/***/ 36274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ isProd; }
/* harmony export */ });
var ENV = "PROD";
var isProd = ENV === "PROD";


/***/ }),

/***/ 37572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ sentryLogError; }
/* harmony export */ });
/* harmony import */ var _sentry_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2558);
/* harmony import */ var _getEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36274);


var showLog = null;
if (true) {
    showLog = localStorage.getItem("CONFIG-SHOW-LOG");
}
var sentryLogError = function(error) {
    if (!_getEnv__WEBPACK_IMPORTED_MODULE_0__/* .isProd */ .B) return;
    if (showLog) console.error(error);
    _sentry_browser__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error);
};


/***/ }),

/***/ 95487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ob": function() { return /* binding */ toBigNumber; },
/* harmony export */   "Q3": function() { return /* binding */ toSignificantDigits; },
/* harmony export */   "Qe": function() { return /* binding */ getDecimalAmount; },
/* harmony export */   "hr": function() { return /* binding */ getDisplayBalanceAmount; },
/* harmony export */   "jV": function() { return /* binding */ getDisplayDecimalAmount; },
/* harmony export */   "yS": function() { return /* binding */ getTokenAmount; }
/* harmony export */ });
/* unused harmony exports getBalanceAmount, toBN */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54146);
/* harmony import */ var _polkadot_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13072);
/* harmony import */ var _polkadot_util__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_polkadot_util__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _polkadot_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(838);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41050);



var getBalanceAmount = function(amount, decimal) {
    if (amount.isZero()) {
        return BN_ZERO;
    }
    var decimals = BN_TEN.pow(new BN(decimal));
    var balance = amount.div(decimals);
    return balance;
};
var getDisplayDecimalAmount = function(amount, decimal) {
    if (!amount || amount.isZero() || !decimal) {
        return "0";
    }
    var decimals = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(10).pow(new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(decimal));
    var balance = amount.multipliedBy(decimals);
    return balance.toFixed(0, 1);
};
function getDecimalAmount(amount, decimal) {
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amount, (_polkadot_util__WEBPACK_IMPORTED_MODULE_2___default()))) {
        if (amount.isZero()) {
            return _polkadot_util__WEBPACK_IMPORTED_MODULE_3__/* .BN_ZERO */ .nw;
        }
        var decimals = _polkadot_util__WEBPACK_IMPORTED_MODULE_3__/* .BN_TEN.pow */ .aP.pow(new (_polkadot_util__WEBPACK_IMPORTED_MODULE_2___default())(decimal));
        var balance = amount.mul(decimals);
        return balance;
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amount, bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)) {
        if (amount.isZero()) {
            return (0,bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(0);
        }
        var decimals1 = (0,bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(10).pow((0,bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(decimal));
        var balance1 = amount.multipliedBy(decimals1);
        return balance1;
    }
    throw new Error("Expected BN or BigNumber, but got '".concat(amount, "'."));
}
var toBigNumber = function(num) {
    return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z((num === null || num === void 0 ? void 0 : num.toString()) || "0");
};
var toBN = function(num, decimal) {
    var amount = new BigNumber(num);
    var decimals = new BigNumber(10).pow(decimal || 18);
    var balance = amount.times(decimals);
    return new BN(balance.toString());
};
/** user side amount (divided by decimal) **/ var getTokenAmount = function(amount, decimal) {
    if (!amount || amount.isZero()) {
        return new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(0);
    }
    var decimals = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(10).pow(decimal || 18);
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amount, (_polkadot_util__WEBPACK_IMPORTED_MODULE_2___default()))) {
        var balance = toBigNumber(amount).dividedBy(decimals);
        return balance;
    }
    var balance1 = amount.dividedBy(decimals);
    return balance1;
};
/** user side amount in string with significance (divided by decimal) **/ var getDisplayBalanceAmount = function(amount, decimal, sd) {
    var result = getTokenAmount(amount, decimal);
    if (!sd) {
        return result.toFixed();
    }
    return toSignificantDigits(result, sd);
};
var toSignificantDigits = function(amount, sd) {
    if (amount.gte(1)) {
        if (sd < 8) return Number(amount.toPrecision(sd, 1)).toString();
        return amount.toPrecision(sd, 1);
    } else {
        var decimals = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(10).pow(sd);
        var limit = new bignumber_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z(1).div(decimals);
        if (amount.isZero()) {
            return "0";
        } else if (amount.gt(limit)) {
            return Number(amount.toPrecision(sd, 1)).toString();
        } else {
            return "< ".concat(limit);
        }
    }
};


/***/ }),

/***/ 58269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Contract; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(49573);
// EXTERNAL MODULE: ./node_modules/@polkadot/api-contract/Abi/index.js + 6 modules
var Abi = __webpack_require__(85220);
// EXTERNAL MODULE: ./node_modules/@polkadot/api-contract/promise/index.js + 4 modules
var promise = __webpack_require__(64760);
;// CONCATENATED MODULE: ./utils/artifacts/pair_contract.json
var pair_contract_namespaceObject = JSON.parse('{"source":{"hash":"0x00f7103fd3007dd663c7be2d3e6b6a77dd9c5820504e87db984bb07124bdfb08","language":"ink! 4.0.1","compiler":"rustc 1.68.0-nightly","build_info":{"build_mode":"Release","cargo_contract_version":"2.0.2","rust_toolchain":"nightly-aarch64-apple-darwin","wasm_opt_settings":{"keep_debug_symbols":false,"optimization_passes":"Z"}}},"contract":{"name":"pair_contract","version":"0.1.1","authors":["Apolloswap <info@apolloswap.org>"]},"spec":{"constructors":[{"args":[],"docs":[],"label":"new","payable":false,"returnType":{"displayName":["ink_primitives","ConstructorResult"],"type":10},"selector":"0x9bae9d5e"}],"docs":[],"events":[{"args":[{"docs":[],"indexed":true,"label":"sender","type":{"displayName":["AccountId"],"type":4}},{"docs":[],"indexed":false,"label":"amount_0","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":false,"label":"amount_1","type":{"displayName":["Balance"],"type":0}}],"docs":[],"label":"Mint"},{"args":[{"docs":[],"indexed":true,"label":"sender","type":{"displayName":["AccountId"],"type":4}},{"docs":[],"indexed":false,"label":"amount_0","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":false,"label":"amount_1","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":true,"label":"to","type":{"displayName":["AccountId"],"type":4}}],"docs":[],"label":"Burn"},{"args":[{"docs":[],"indexed":true,"label":"sender","type":{"displayName":["AccountId"],"type":4}},{"docs":[],"indexed":false,"label":"amount_0_in","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":false,"label":"amount_1_in","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":false,"label":"amount_0_out","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":false,"label":"amount_1_out","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":true,"label":"to","type":{"displayName":["AccountId"],"type":4}}],"docs":[],"label":"Swap"},{"args":[{"docs":[],"indexed":false,"label":"reserve_0","type":{"displayName":["Balance"],"type":0}},{"docs":[],"indexed":false,"label":"reserve_1","type":{"displayName":["Balance"],"type":0}}],"docs":[],"label":"Sync"},{"args":[{"docs":[],"indexed":true,"label":"from","type":{"displayName":["Option"],"type":36}},{"docs":[],"indexed":true,"label":"to","type":{"displayName":["Option"],"type":36}},{"docs":[],"indexed":false,"label":"value","type":{"displayName":["Balance"],"type":0}}],"docs":[],"label":"Transfer"},{"args":[{"docs":[],"indexed":true,"label":"owner","type":{"displayName":["AccountId"],"type":4}},{"docs":[],"indexed":true,"label":"spender","type":{"displayName":["AccountId"],"type":4}},{"docs":[],"indexed":false,"label":"value","type":{"displayName":["Balance"],"type":0}}],"docs":[],"label":"Approval"}],"lang_error":{"displayName":["ink","LangError"],"type":11},"messages":[{"args":[],"docs":[" Returns the total token supply."],"label":"PSP22::total_supply","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":12},"selector":"0x162df8c2"},{"args":[{"label":"spender","type":{"displayName":["psp22_external","IncreaseAllowanceInput1"],"type":4}},{"label":"delta_value","type":{"displayName":["psp22_external","IncreaseAllowanceInput2"],"type":0}}],"docs":[" Atomically increases the allowance granted to `spender` by the caller.",""," An `Approval` event is emitted.",""," # Errors",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::increase_allowance","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0x96d6b57a"},{"args":[{"label":"owner","type":{"displayName":["psp22_external","BalanceOfInput1"],"type":4}}],"docs":[" Returns the account Balance for the specified `owner`.",""," Returns `0` if the account is non-existent."],"label":"PSP22::balance_of","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":12},"selector":"0x6568382f"},{"args":[{"label":"from","type":{"displayName":["psp22_external","TransferFromInput1"],"type":4}},{"label":"to","type":{"displayName":["psp22_external","TransferFromInput2"],"type":4}},{"label":"value","type":{"displayName":["psp22_external","TransferFromInput3"],"type":0}},{"label":"data","type":{"displayName":["psp22_external","TransferFromInput4"],"type":2}}],"docs":[],"label":"PSP22::transfer_from","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0x54b3c76e"},{"args":[{"label":"owner","type":{"displayName":["psp22_external","AllowanceInput1"],"type":4}},{"label":"spender","type":{"displayName":["psp22_external","AllowanceInput2"],"type":4}}],"docs":[" Returns the amount which `spender` is still allowed to withdraw from `owner`.",""," Returns `0` if no allowance has been set `0`."],"label":"PSP22::allowance","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":12},"selector":"0x4d47d921"},{"args":[{"label":"spender","type":{"displayName":["psp22_external","DecreaseAllowanceInput1"],"type":4}},{"label":"delta_value","type":{"displayName":["psp22_external","DecreaseAllowanceInput2"],"type":0}}],"docs":[" Atomically decreases the allowance granted to `spender` by the caller.",""," An `Approval` event is emitted.",""," # Errors",""," Returns `InsufficientAllowance` error if there are not enough tokens allowed"," by owner for `spender`.",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::decrease_allowance","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0xfecb57d5"},{"args":[{"label":"to","type":{"displayName":["psp22_external","TransferInput1"],"type":4}},{"label":"value","type":{"displayName":["psp22_external","TransferInput2"],"type":0}},{"label":"data","type":{"displayName":["psp22_external","TransferInput3"],"type":2}}],"docs":[" Transfers `value` amount of tokens from the caller\'s account to account `to`"," with additional `data` in unspecified format.",""," On success a `Transfer` event is emitted.",""," # Errors",""," Returns `InsufficientBalance` error if there are not enough tokens on"," the caller\'s account Balance.",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::transfer","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0xdb20f9f5"},{"args":[{"label":"spender","type":{"displayName":["psp22_external","ApproveInput1"],"type":4}},{"label":"value","type":{"displayName":["psp22_external","ApproveInput2"],"type":0}}],"docs":[" Allows `spender` to withdraw from the caller\'s account multiple times, up to"," the `value` amount.",""," If this function is called again it overwrites the current allowance with `value`.",""," An `Approval` event is emitted.",""," # Errors",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::approve","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0xb20f1bbd"},{"args":[],"docs":[" Returns the token symbol."],"label":"PSP22Metadata::token_symbol","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":16},"selector":"0x34205be5"},{"args":[],"docs":[" Returns the token decimals."],"label":"PSP22Metadata::token_decimals","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":18},"selector":"0x7271b782"},{"args":[],"docs":[" Returns the token name."],"label":"PSP22Metadata::token_name","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":16},"selector":"0x3d261bd4"},{"args":[],"docs":[" Returns the address of the current owner."],"label":"Ownable::owner","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":19},"selector":"0x4fa43c8c"},{"args":[],"docs":[" Leaves the contract without owner. It will not be possible to call"," owner\'s functions anymore. Can only be called by the current owner.",""," NOTE: Renouncing ownership will leave the contract without an owner,"," thereby removing any functionality that is only available to the owner.",""," On success a `OwnershipTransferred` event is emitted.",""," # Errors",""," Panics with `CallerIsNotOwner` error if caller is not owner"],"label":"Ownable::renounce_ownership","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":20},"selector":"0x5e228753"},{"args":[{"label":"new_owner","type":{"displayName":["ownable_external","TransferOwnershipInput1"],"type":4}}],"docs":[" Transfers ownership of the contract to a `new_owner`."," Can only be called by the current owner.",""," On success a `OwnershipTransferred` event is emitted.",""," # Errors",""," Panics with `CallerIsNotOwner` error if caller is not owner.",""," Panics with `NewOwnerIsZero` error if new owner\'s address is zero."],"label":"Ownable::transfer_ownership","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":20},"selector":"0x11f43efd"},{"args":[],"docs":[" Returns the account ID of token_0.",""," # Returns",""," * The account ID of token_0."],"label":"Pair::get_token_0","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":19},"selector":"0x7aeb98a8"},{"args":[],"docs":[" Returns the cumulative price of token 1 in terms of token 0 at the end of the last block in which the reserves were updated."],"label":"Pair::price_1_cumulative_last","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":23},"selector":"0x1dd38d52"},{"args":[],"docs":[" Returns the product of the reserves of the two tokens in the pair at the end of the last transaction in which the reserves were updated."],"label":"Pair::k_last","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":23},"selector":"0xb5c4614f"},{"args":[],"docs":[" Returns the address of the factory contract."],"label":"Pair::factory","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":19},"selector":"0x91b63655"},{"args":[],"docs":[" Returns the reserves of the two tokens in the pair and the timestamp of the last block in which the reserves were updated."],"label":"Pair::get_reserves","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":24},"selector":"0x5a21e3fc"},{"args":[{"label":"to","type":{"displayName":["pair_external","BurnInput1"],"type":4}}],"docs":[" Burns the specified amount of liquidity tokens and returns the corresponding amounts of the two tokens in the pair to the specified recipient.",""," # Arguments",""," * `to` - The address of the recipient.",""," # Errors",""," Returns an error if the burning fails."],"label":"Pair::burn","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":26},"selector":"0x0221c524"},{"args":[],"docs":[" Returns the account ID of token_1.",""," # Returns",""," * The account ID of token_1."],"label":"Pair::get_token_1","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":19},"selector":"0xa5b0616f"},{"args":[{"label":"token_0","type":{"displayName":["pair_external","InitializeInput1"],"type":4}},{"label":"token_1","type":{"displayName":["pair_external","InitializeInput2"],"type":4}}],"docs":[" Initializes the pair with the addresses of the two tokens.",""," # Arguments",""," * `token_0` - The address of the first token."," * `token_1` - The address of the second token.",""," # Errors",""," Returns an error if the caller is not the owner of the contract."],"label":"Pair::initialize","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":32},"selector":"0xd372021c"},{"args":[{"label":"to","type":{"displayName":["pair_external","MintInput1"],"type":4}}],"docs":[" Mints liquidity tokens to the specified recipient in exchange for the given amounts of the two tokens in the pair.",""," # Arguments",""," * `to` - The address of the recipient.",""," # Errors",""," Returns an error if the minting fails."],"label":"Pair::mint","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":34},"selector":"0x4eaaf722"},{"args":[{"label":"to","type":{"displayName":["pair_external","SkimInput1"],"type":4}}],"docs":[" Transfers any tokens that are in excess of the reserves to the specified account.",""," # Arguments",""," * `to` - The account to send the excess tokens to.",""," # Errors",""," * If the subtraction overflows."],"label":"Pair::skim","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":32},"selector":"0x51c32781"},{"args":[],"docs":[" Updates the reserves to match the current balances of the tokens.",""," # Errors",""," * If the subtraction or multiplication overflows."],"label":"Pair::sync","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":32},"selector":"0x79261d93"},{"args":[],"docs":[" Returns the cumulative price of token 0 in terms of token 1 at the end of the last block in which the reserves were updated."],"label":"Pair::price_0_cumulative_last","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":23},"selector":"0xf4d99951"},{"args":[{"label":"amount_0_out","type":{"displayName":["pair_external","SwapInput1"],"type":0}},{"label":"amount_1_out","type":{"displayName":["pair_external","SwapInput2"],"type":0}},{"label":"to","type":{"displayName":["pair_external","SwapInput3"],"type":4}},{"label":"data","type":{"displayName":["pair_external","SwapInput4"],"type":2}}],"docs":[" Swaps an amount of token_0 for an amount of token_1, or vice versa.",""," # Arguments",""," * `amount_0_out` - The amount of token_0 to swap out."," * `amount_1_out` - The amount of token_1 to swap out."," * `to` - The account to send the swapped tokens to."," * `data` - Additional data to be passed to the recipient.",""," # Errors",""," * `InsufficientOutputAmount` - If both `amount_0_out` and `amount_1_out` are zero."," * `InsufficientLiquidity` - If either `amount_0_out` or `amount_1_out` is greater than the reserves."," * `InvalidTo` - If `to` is the same as either `token_0` or `token_1`."," * `SubUnderFlow4` - If `amount_0_out` is greater than the reserves of token_0."," * `SubUnderFlow5` - If `amount_0_out` is greater than the reserves of token_0."," * `SubUnderFlow6` - If `amount_0_out` is greater than the reserves of token_0."," * `SubUnderFlow7` - If `amount_1_out` is greater than the reserves of token_1."," * `SubUnderFlow8` - If `amount_1_out` is greater than the reserves of token_1."," * `SubUnderFlow9` - If `amount_1_out` is greater than the reserves of token_1."," * `InsufficientInputAmount` - If both `amount_0_in` and `amount_1_in` are zero."," * `MulOverFlow7` - If `balance_0` multiplied by 1000 overflows."," * `MulOverFlow8` - If `amount_0_in` multiplied by 3 overflows."," * `SubUnderFlow10` - If `balance_0_adjusted` is less than `amount_0_in` multiplied by 3."," * `MulOverFlow9` - If `balance_1` multiplied by 1000 overflows."," * `MulOverFlow10` - If `amount_1_in` multiplied by 3 overflows."," * `SubUnderFlow11` - If `balance_1_adjusted` is less than `amount_1_in` multiplied by 3."," * `K` - If the product of `balance_0_adjusted` and `balance_1_adjusted` is less than the product of the reserves of token_0 and token_1 multiplied by 1000^2."," * `MulOverFlow14` - If the product of the reserves of token_0 and token_1 multiplied by 1000^2 overflows.",""," # Returns",""," * `Result<(), PairError>` - Returns `Ok(())` if the swap is successful, or an error if the swap fails."],"label":"Pair::swap","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":32},"selector":"0xc4b60ed8"}]},"storage":{"root":{"layout":{"struct":{"fields":[{"layout":{"struct":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":0}},"name":"supply"},{"layout":{"root":{"layout":{"leaf":{"key":"0x1d458d3b","ty":0}},"root_key":"0x1d458d3b"}},"name":"balances"},{"layout":{"root":{"layout":{"leaf":{"key":"0x0abd72fb","ty":0}},"root_key":"0x0abd72fb"}},"name":"allowances"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":1}},"name":"0"}],"name":"Some"}}}},"name":"_reserved"}],"name":"Data"}},"name":"psp22"},{"layout":{"struct":{"fields":[{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":2}},"name":"0"}],"name":"Some"}}}},"name":"name"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":2}},"name":"0"}],"name":"Some"}}}},"name":"symbol"},{"layout":{"leaf":{"key":"0x00000000","ty":3}},"name":"decimals"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":1}},"name":"0"}],"name":"Some"}}}},"name":"_reserved"}],"name":"Data"}},"name":"metadata"},{"layout":{"struct":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":4}},"name":"owner"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":1}},"name":"0"}],"name":"Some"}}}},"name":"_reserved"}],"name":"Data"}},"name":"ownable"},{"layout":{"struct":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":3}},"name":"status"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":1}},"name":"0"}],"name":"Some"}}}},"name":"_reserved"}],"name":"Data"}},"name":"guard"},{"layout":{"struct":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":4}},"name":"factory"},{"layout":{"leaf":{"key":"0x00000000","ty":4}},"name":"token_0"},{"layout":{"leaf":{"key":"0x00000000","ty":4}},"name":"token_1"},{"layout":{"leaf":{"key":"0x00000000","ty":0}},"name":"reserve_0"},{"layout":{"leaf":{"key":"0x00000000","ty":0}},"name":"reserve_1"},{"layout":{"leaf":{"key":"0x00000000","ty":6}},"name":"block_timestamp_last"},{"layout":{"leaf":{"key":"0x00000000","ty":7}},"name":"price_0_cumulative_last"},{"layout":{"leaf":{"key":"0x00000000","ty":7}},"name":"price_1_cumulative_last"},{"layout":{"leaf":{"key":"0x00000000","ty":7}},"name":"k_last"}],"name":"Data"}},"name":"pair"}],"name":"PairContract"}},"root_key":"0x00000000"}},"types":[{"id":0,"type":{"def":{"primitive":"u128"}}},{"id":1,"type":{"def":{"tuple":[]}}},{"id":2,"type":{"def":{"sequence":{"type":3}}}},{"id":3,"type":{"def":{"primitive":"u8"}}},{"id":4,"type":{"def":{"composite":{"fields":[{"type":5,"typeName":"[u8; 32]"}]}},"path":["ink_primitives","types","AccountId"]}},{"id":5,"type":{"def":{"array":{"len":32,"type":3}}}},{"id":6,"type":{"def":{"primitive":"u64"}}},{"id":7,"type":{"def":{"composite":{"fields":[{"type":8,"typeName":"U256"}]}},"path":["logics","traits","types","WrappedU256"]}},{"id":8,"type":{"def":{"composite":{"fields":[{"type":9,"typeName":"[u64; 4]"}]}},"path":["primitive_types","U256"]}},{"id":9,"type":{"def":{"array":{"len":4,"type":6}}}},{"id":10,"type":{"def":{"variant":{"variants":[{"fields":[{"type":1}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":1},{"name":"E","type":11}],"path":["Result"]}},{"id":11,"type":{"def":{"variant":{"variants":[{"index":1,"name":"CouldNotReadInput"}]}},"path":["ink_primitives","LangError"]}},{"id":12,"type":{"def":{"variant":{"variants":[{"fields":[{"type":0}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":0},{"name":"E","type":11}],"path":["Result"]}},{"id":13,"type":{"def":{"variant":{"variants":[{"fields":[{"type":14}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":14},{"name":"E","type":11}],"path":["Result"]}},{"id":14,"type":{"def":{"variant":{"variants":[{"fields":[{"type":1}],"index":0,"name":"Ok"},{"fields":[{"type":15}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":1},{"name":"E","type":15}],"path":["Result"]}},{"id":15,"type":{"def":{"variant":{"variants":[{"fields":[{"type":2,"typeName":"String"}],"index":0,"name":"Custom"},{"index":1,"name":"InsufficientBalance"},{"index":2,"name":"InsufficientAllowance"},{"index":3,"name":"ZeroRecipientAddress"},{"index":4,"name":"ZeroSenderAddress"},{"fields":[{"type":2,"typeName":"String"}],"index":5,"name":"SafeTransferCheckFailed"}]}},"path":["openbrush_contracts","traits","errors","psp22","PSP22Error"]}},{"id":16,"type":{"def":{"variant":{"variants":[{"fields":[{"type":17}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":17},{"name":"E","type":11}],"path":["Result"]}},{"id":17,"type":{"def":{"variant":{"variants":[{"index":0,"name":"None"},{"fields":[{"type":2}],"index":1,"name":"Some"}]}},"params":[{"name":"T","type":2}],"path":["Option"]}},{"id":18,"type":{"def":{"variant":{"variants":[{"fields":[{"type":3}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":3},{"name":"E","type":11}],"path":["Result"]}},{"id":19,"type":{"def":{"variant":{"variants":[{"fields":[{"type":4}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":4},{"name":"E","type":11}],"path":["Result"]}},{"id":20,"type":{"def":{"variant":{"variants":[{"fields":[{"type":21}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":21},{"name":"E","type":11}],"path":["Result"]}},{"id":21,"type":{"def":{"variant":{"variants":[{"fields":[{"type":1}],"index":0,"name":"Ok"},{"fields":[{"type":22}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":1},{"name":"E","type":22}],"path":["Result"]}},{"id":22,"type":{"def":{"variant":{"variants":[{"index":0,"name":"CallerIsNotOwner"},{"index":1,"name":"NewOwnerIsZero"}]}},"path":["openbrush_contracts","traits","errors","ownable","OwnableError"]}},{"id":23,"type":{"def":{"variant":{"variants":[{"fields":[{"type":7}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":7},{"name":"E","type":11}],"path":["Result"]}},{"id":24,"type":{"def":{"variant":{"variants":[{"fields":[{"type":25}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":25},{"name":"E","type":11}],"path":["Result"]}},{"id":25,"type":{"def":{"tuple":[0,0,6]}}},{"id":26,"type":{"def":{"variant":{"variants":[{"fields":[{"type":27}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":27},{"name":"E","type":11}],"path":["Result"]}},{"id":27,"type":{"def":{"variant":{"variants":[{"fields":[{"type":28}],"index":0,"name":"Ok"},{"fields":[{"type":29}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":28},{"name":"E","type":29}],"path":["Result"]}},{"id":28,"type":{"def":{"tuple":[0,0]}}},{"id":29,"type":{"def":{"variant":{"variants":[{"fields":[{"type":15,"typeName":"PSP22Error"}],"index":0,"name":"PSP22Error"},{"fields":[{"type":22,"typeName":"OwnableError"}],"index":1,"name":"OwnableError"},{"fields":[{"type":30,"typeName":"ReentrancyGuardError"}],"index":2,"name":"ReentrancyGuardError"},{"fields":[{"type":31,"typeName":"SwapCalleeError"}],"index":3,"name":"SwapCalleeError"},{"index":4,"name":"K"},{"index":5,"name":"InsufficientLiquidityMinted"},{"index":6,"name":"InsufficientLiquidityBurned"},{"index":7,"name":"InsufficientOutputAmount"},{"index":8,"name":"InsufficientLiquidity"},{"index":9,"name":"InsufficientInputAmount"},{"index":10,"name":"SafeTransferFailed"},{"index":11,"name":"InvalidTo"},{"index":12,"name":"Overflow"},{"index":13,"name":"Locked"},{"index":14,"name":"SubUnderFlow1"},{"index":15,"name":"SubUnderFlow2"},{"index":16,"name":"SubUnderFlow3"},{"index":17,"name":"SubUnderFlow4"},{"index":18,"name":"SubUnderFlow5"},{"index":19,"name":"SubUnderFlow6"},{"index":20,"name":"SubUnderFlow7"},{"index":21,"name":"SubUnderFlow8"},{"index":22,"name":"SubUnderFlow9"},{"index":23,"name":"SubUnderFlow10"},{"index":24,"name":"SubUnderFlow11"},{"index":25,"name":"SubUnderFlow12"},{"index":26,"name":"SubUnderFlow13"},{"index":27,"name":"SubUnderFlow14"},{"index":28,"name":"MulOverFlow1"},{"index":29,"name":"MulOverFlow2"},{"index":30,"name":"MulOverFlow3"},{"index":31,"name":"MulOverFlow4"},{"index":32,"name":"MulOverFlow5"},{"index":33,"name":"MulOverFlow6"},{"index":34,"name":"MulOverFlow7"},{"index":35,"name":"MulOverFlow8"},{"index":36,"name":"MulOverFlow9"},{"index":37,"name":"MulOverFlow10"},{"index":38,"name":"MulOverFlow11"},{"index":39,"name":"MulOverFlow12"},{"index":40,"name":"MulOverFlow13"},{"index":41,"name":"MulOverFlow14"},{"index":42,"name":"DivByZero1"},{"index":43,"name":"DivByZero2"},{"index":44,"name":"DivByZero3"},{"index":45,"name":"DivByZero4"},{"index":46,"name":"DivByZero5"},{"index":47,"name":"AddOverflow1"},{"index":48,"name":"CastOverflow1"},{"index":49,"name":"CastOverflow2"}]}},"path":["logics","traits","pair","PairError"]}},{"id":30,"type":{"def":{"variant":{"variants":[{"index":0,"name":"ReentrantCall"}]}},"path":["openbrush_contracts","traits","errors","reentrancy_guard","ReentrancyGuardError"]}},{"id":31,"type":{"def":{"variant":{"variants":[{"fields":[{"type":2,"typeName":"String"}],"index":0,"name":"Custom"}]}},"path":["logics","traits","swap_callee","SwapCalleeError"]}},{"id":32,"type":{"def":{"variant":{"variants":[{"fields":[{"type":33}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":33},{"name":"E","type":11}],"path":["Result"]}},{"id":33,"type":{"def":{"variant":{"variants":[{"fields":[{"type":1}],"index":0,"name":"Ok"},{"fields":[{"type":29}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":1},{"name":"E","type":29}],"path":["Result"]}},{"id":34,"type":{"def":{"variant":{"variants":[{"fields":[{"type":35}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":35},{"name":"E","type":11}],"path":["Result"]}},{"id":35,"type":{"def":{"variant":{"variants":[{"fields":[{"type":0}],"index":0,"name":"Ok"},{"fields":[{"type":29}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":0},{"name":"E","type":29}],"path":["Result"]}},{"id":36,"type":{"def":{"variant":{"variants":[{"index":0,"name":"None"},{"fields":[{"type":4}],"index":1,"name":"Some"}]}},"params":[{"name":"T","type":4}],"path":["Option"]}}],"version":"4"}');
// EXTERNAL MODULE: ./node_modules/@arthswap/typechain-types/dist/index.js
var dist = __webpack_require__(41827);
;// CONCATENATED MODULE: ./utils/types/data/pair_contract.json
var data_pair_contract_namespaceObject = JSON.parse('{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"2":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"3":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false},"4":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"5":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"6":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false},"7":{"name":"WrappedU256","body":{"":{"name":"U256","body":{"":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"8":{"name":"U256","body":{"":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"9":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"11":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"12":{"name":"Result<ReturnNumber, LangError","body":{"ok":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"13":{"name":"Result<Result<null, PSP22Error, LangError","body":{"ok":{"name":"Result<null, PSP22Error","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"14":{"name":"Result<null, PSP22Error","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"15":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"16":{"name":"Result<Option, LangError","body":{"ok":{"name":"Option","body":{"0":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"17":{"name":"Option","body":{"0":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"18":{"name":"Result<number, LangError","body":{"ok":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"19":{"name":"Result<AccountId, LangError","body":{"ok":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"20":{"name":"Result<Result<null, OwnableError, LangError","body":{"ok":{"name":"Result<null, OwnableError","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"21":{"name":"Result<null, OwnableError","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"22":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"23":{"name":"Result<WrappedU256, LangError","body":{"ok":{"name":"WrappedU256","body":{"":{"name":"U256","body":{"":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"24":{"name":"Result<Tuple, LangError","body":{"ok":{"name":"Tuple","body":{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"2":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"25":{"name":"Tuple","body":{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"2":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"26":{"name":"Result<Result<Tuple, PairError, LangError","body":{"ok":{"name":"Result<Tuple, PairError","body":{"ok":{"name":"Tuple","body":{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"err":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"27":{"name":"Result<Tuple, PairError","body":{"ok":{"name":"Tuple","body":{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"err":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"28":{"name":"Tuple","body":{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"29":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"30":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"31":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"32":{"name":"Result<Result<null, PairError, LangError","body":{"ok":{"name":"Result<null, PairError","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"33":{"name":"Result<null, PairError","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"34":{"name":"Result<Result<ReturnNumber, PairError, LangError","body":{"ok":{"name":"Result<ReturnNumber, PairError","body":{"ok":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"err":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"35":{"name":"Result<ReturnNumber, PairError","body":{"ok":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"err":{"name":"PairError","body":{"psp22Error":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"ownableError":{"name":"OwnableError","body":{"CallerIsNotOwner":null,"NewOwnerIsZero":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"reentrancyGuardError":{"name":"ReentrancyGuardError","body":{"ReentrantCall":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"swapCalleeError":{"name":"SwapCalleeError","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"k":null,"insufficientLiquidityMinted":null,"insufficientLiquidityBurned":null,"insufficientOutputAmount":null,"insufficientLiquidity":null,"insufficientInputAmount":null,"safeTransferFailed":null,"invalidTo":null,"overflow":null,"locked":null,"subUnderFlow1":null,"subUnderFlow2":null,"subUnderFlow3":null,"subUnderFlow4":null,"subUnderFlow5":null,"subUnderFlow6":null,"subUnderFlow7":null,"subUnderFlow8":null,"subUnderFlow9":null,"subUnderFlow10":null,"subUnderFlow11":null,"subUnderFlow12":null,"subUnderFlow13":null,"subUnderFlow14":null,"mulOverFlow1":null,"mulOverFlow2":null,"mulOverFlow3":null,"mulOverFlow4":null,"mulOverFlow5":null,"mulOverFlow6":null,"mulOverFlow7":null,"mulOverFlow8":null,"mulOverFlow9":null,"mulOverFlow10":null,"mulOverFlow11":null,"mulOverFlow12":null,"mulOverFlow13":null,"mulOverFlow14":null,"divByZero1":null,"divByZero2":null,"divByZero3":null,"divByZero4":null,"divByZero5":null,"addOverflow1":null,"castOverflow1":null,"castOverflow2":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"36":{"name":"Option","body":{"0":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}}');
;// CONCATENATED MODULE: ./utils/types/query/pair_contract.ts
/* This file is auto-generated */ 



var Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(nativeContract, nativeApi, callerAddress) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__nativeContract = nativeContract;
        this.__callerAddress = callerAddress;
        this.__apiPromise = nativeApi;
    }
    var _proto = Methods.prototype;
    /**
	* totalSupply
	*
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["totalSupply"] = function totalSupply(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::totalSupply", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[12]);
        });
    };
    /**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[13]);
        });
    };
    /**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["balanceOf"] = function balanceOf(owner, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::balanceOf", [
            owner
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[12]);
        });
    };
    /**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[13]);
        });
    };
    /**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["allowance"] = function allowance(owner, spender, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::allowance", [
            owner,
            spender
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[12]);
        });
    };
    /**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[13]);
        });
    };
    /**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["transfer"] = function transfer(to, value, data, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::transfer", [
            to,
            value,
            data
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[13]);
        });
    };
    /**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["approve"] = function approve(spender, value, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::approve", [
            spender,
            value
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[13]);
        });
    };
    /**
	* tokenSymbol
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenSymbol", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[16]);
        });
    };
    /**
	* tokenDecimals
	*
	* @returns { Result<number, ReturnTypes.LangError> }
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenDecimals", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[18]);
        });
    };
    /**
	* tokenName
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenName"] = function tokenName(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenName", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[16]);
        });
    };
    /**
	* owner
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["owner"] = function owner(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "ownable::owner", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* renounceOwnership
	*
	* @returns { Result<Result<null, ReturnTypes.OwnableError>, ReturnTypes.LangError> }
	*/ _proto["renounceOwnership"] = function renounceOwnership(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "ownable::renounceOwnership", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[20]);
        });
    };
    /**
	* transferOwnership
	*
	* @param { ArgumentTypes.AccountId } newOwner,
	* @returns { Result<Result<null, ReturnTypes.OwnableError>, ReturnTypes.LangError> }
	*/ _proto["transferOwnership"] = function transferOwnership(newOwner, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "ownable::transferOwnership", [
            newOwner
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[20]);
        });
    };
    /**
	* getToken0
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["getToken0"] = function getToken0(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::getToken0", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* price1CumulativeLast
	*
	* @returns { Result<ReturnTypes.WrappedU256, ReturnTypes.LangError> }
	*/ _proto["price1CumulativeLast"] = function price1CumulativeLast(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::price1CumulativeLast", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[23]);
        });
    };
    /**
	* kLast
	*
	* @returns { Result<ReturnTypes.WrappedU256, ReturnTypes.LangError> }
	*/ _proto["kLast"] = function kLast(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::kLast", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[23]);
        });
    };
    /**
	* factory
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["factory"] = function factory(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::factory", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* getReserves
	*
	* @returns { Result<[ReturnNumber, ReturnNumber, number], ReturnTypes.LangError> }
	*/ _proto["getReserves"] = function getReserves(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::getReserves", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[24]);
        });
    };
    /**
	* burn
	*
	* @param { ArgumentTypes.AccountId } to,
	* @returns { Result<Result<[ReturnNumber, ReturnNumber], ReturnTypes.PairError>, ReturnTypes.LangError> }
	*/ _proto["burn"] = function burn(to, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::burn", [
            to
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[26]);
        });
    };
    /**
	* getToken1
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["getToken1"] = function getToken1(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::getToken1", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* initialize
	*
	* @param { ArgumentTypes.AccountId } token0,
	* @param { ArgumentTypes.AccountId } token1,
	* @returns { Result<Result<null, ReturnTypes.PairError>, ReturnTypes.LangError> }
	*/ _proto["initialize"] = function initialize(token0, token1, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::initialize", [
            token0,
            token1
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[32]);
        });
    };
    /**
	* mint
	*
	* @param { ArgumentTypes.AccountId } to,
	* @returns { Result<Result<ReturnNumber, ReturnTypes.PairError>, ReturnTypes.LangError> }
	*/ _proto["mint"] = function mint(to, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::mint", [
            to
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[34]);
        });
    };
    /**
	* skim
	*
	* @param { ArgumentTypes.AccountId } to,
	* @returns { Result<Result<null, ReturnTypes.PairError>, ReturnTypes.LangError> }
	*/ _proto["skim"] = function skim(to, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::skim", [
            to
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[32]);
        });
    };
    /**
	* sync
	*
	* @returns { Result<Result<null, ReturnTypes.PairError>, ReturnTypes.LangError> }
	*/ _proto["sync"] = function sync(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::sync", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[32]);
        });
    };
    /**
	* price0CumulativeLast
	*
	* @returns { Result<ReturnTypes.WrappedU256, ReturnTypes.LangError> }
	*/ _proto["price0CumulativeLast"] = function price0CumulativeLast(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::price0CumulativeLast", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[23]);
        });
    };
    /**
	* swap
	*
	* @param { (string | number | BN) } amount0Out,
	* @param { (string | number | BN) } amount1Out,
	* @param { ArgumentTypes.AccountId } to,
	* @param { Array<(number | string | BN)> } data,
	* @returns { Result<Result<null, ReturnTypes.PairError>, ReturnTypes.LangError> }
	*/ _proto["swap"] = function swap(amount0Out, amount1Out, to, data, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::swap", [
            amount0Out,
            amount1Out,
            to,
            data
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[32]);
        });
    };
    return Methods;
}();


;// CONCATENATED MODULE: ./utils/types/build-extrinsic/pair_contract.ts
/* This file is auto-generated */ 

var pair_contract_Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(nativeContract, apiPromise) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__nativeContract = nativeContract;
        this.__apiPromise = apiPromise;
    }
    var _proto = Methods.prototype;
    /**
	 * totalSupply
	 *
	*/ _proto["totalSupply"] = function totalSupply(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::totalSupply", [], __options);
    };
    /**
	 * increaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	 * balanceOf
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	*/ _proto["balanceOf"] = function balanceOf(owner, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::balanceOf", [
            owner
        ], __options);
    };
    /**
	 * transferFrom
	 *
	 * @param { ArgumentTypes.AccountId } from,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options);
    };
    /**
	 * allowance
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 * @param { ArgumentTypes.AccountId } spender,
	*/ _proto["allowance"] = function allowance(owner, spender, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::allowance", [
            owner,
            spender
        ], __options);
    };
    /**
	 * decreaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	 * transfer
	 *
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	*/ _proto["transfer"] = function transfer(to, value, data, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::transfer", [
            to,
            value,
            data
        ], __options);
    };
    /**
	 * approve
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } value,
	*/ _proto["approve"] = function approve(spender, value, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::approve", [
            spender,
            value
        ], __options);
    };
    /**
	 * tokenSymbol
	 *
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22Metadata::tokenSymbol", [], __options);
    };
    /**
	 * tokenDecimals
	 *
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22Metadata::tokenDecimals", [], __options);
    };
    /**
	 * tokenName
	 *
	*/ _proto["tokenName"] = function tokenName(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22Metadata::tokenName", [], __options);
    };
    /**
	 * owner
	 *
	*/ _proto["owner"] = function owner(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "ownable::owner", [], __options);
    };
    /**
	 * renounceOwnership
	 *
	*/ _proto["renounceOwnership"] = function renounceOwnership(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "ownable::renounceOwnership", [], __options);
    };
    /**
	 * transferOwnership
	 *
	 * @param { ArgumentTypes.AccountId } newOwner,
	*/ _proto["transferOwnership"] = function transferOwnership(newOwner, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "ownable::transferOwnership", [
            newOwner
        ], __options);
    };
    /**
	 * getToken0
	 *
	*/ _proto["getToken0"] = function getToken0(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::getToken0", [], __options);
    };
    /**
	 * price1CumulativeLast
	 *
	*/ _proto["price1CumulativeLast"] = function price1CumulativeLast(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::price1CumulativeLast", [], __options);
    };
    /**
	 * kLast
	 *
	*/ _proto["kLast"] = function kLast(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::kLast", [], __options);
    };
    /**
	 * factory
	 *
	*/ _proto["factory"] = function factory(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::factory", [], __options);
    };
    /**
	 * getReserves
	 *
	*/ _proto["getReserves"] = function getReserves(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::getReserves", [], __options);
    };
    /**
	 * burn
	 *
	 * @param { ArgumentTypes.AccountId } to,
	*/ _proto["burn"] = function burn(to, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::burn", [
            to
        ], __options);
    };
    /**
	 * getToken1
	 *
	*/ _proto["getToken1"] = function getToken1(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::getToken1", [], __options);
    };
    /**
	 * initialize
	 *
	 * @param { ArgumentTypes.AccountId } token0,
	 * @param { ArgumentTypes.AccountId } token1,
	*/ _proto["initialize"] = function initialize(token0, token1, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::initialize", [
            token0,
            token1
        ], __options);
    };
    /**
	 * mint
	 *
	 * @param { ArgumentTypes.AccountId } to,
	*/ _proto["mint"] = function mint(to, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::mint", [
            to
        ], __options);
    };
    /**
	 * skim
	 *
	 * @param { ArgumentTypes.AccountId } to,
	*/ _proto["skim"] = function skim(to, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::skim", [
            to
        ], __options);
    };
    /**
	 * sync
	 *
	*/ _proto["sync"] = function sync(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::sync", [], __options);
    };
    /**
	 * price0CumulativeLast
	 *
	*/ _proto["price0CumulativeLast"] = function price0CumulativeLast(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::price0CumulativeLast", [], __options);
    };
    /**
	 * swap
	 *
	 * @param { (string | number | BN) } amount0Out,
	 * @param { (string | number | BN) } amount1Out,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { Array<(number | string | BN)> } data,
	*/ _proto["swap"] = function swap(amount0Out, amount1Out, to, data, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "pair::swap", [
            amount0Out,
            amount1Out,
            to,
            data
        ], __options);
    };
    return Methods;
}();


;// CONCATENATED MODULE: ./utils/types/tx-sign-and-send/pair_contract.ts
/* This file is auto-generated */ 

var tx_sign_and_send_pair_contract_Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(apiPromise, nativeContract, keyringPair) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__apiPromise = apiPromise;
        this.__nativeContract = nativeContract;
        this.__keyringPair = keyringPair;
    }
    var _proto = Methods.prototype;
    /**
	* totalSupply
	*
	*/ _proto["totalSupply"] = function totalSupply(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::totalSupply", [], __options, __signerOptions);
    };
    /**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options, __signerOptions);
    };
    /**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	*/ _proto["balanceOf"] = function balanceOf(owner, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::balanceOf", [
            owner
        ], __options, __signerOptions);
    };
    /**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options, __signerOptions);
    };
    /**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	*/ _proto["allowance"] = function allowance(owner, spender, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::allowance", [
            owner,
            spender
        ], __options, __signerOptions);
    };
    /**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options, __signerOptions);
    };
    /**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	*/ _proto["transfer"] = function transfer(to, value, data, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transfer", [
            to,
            value,
            data
        ], __options, __signerOptions);
    };
    /**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	*/ _proto["approve"] = function approve(spender, value, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::approve", [
            spender,
            value
        ], __options, __signerOptions);
    };
    /**
	* tokenSymbol
	*
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenSymbol", [], __options, __signerOptions);
    };
    /**
	* tokenDecimals
	*
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenDecimals", [], __options, __signerOptions);
    };
    /**
	* tokenName
	*
	*/ _proto["tokenName"] = function tokenName(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenName", [], __options, __signerOptions);
    };
    /**
	* owner
	*
	*/ _proto["owner"] = function owner(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::owner", [], __options, __signerOptions);
    };
    /**
	* renounceOwnership
	*
	*/ _proto["renounceOwnership"] = function renounceOwnership(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::renounceOwnership", [], __options, __signerOptions);
    };
    /**
	* transferOwnership
	*
	* @param { ArgumentTypes.AccountId } newOwner,
	*/ _proto["transferOwnership"] = function transferOwnership(newOwner, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::transferOwnership", [
            newOwner
        ], __options, __signerOptions);
    };
    /**
	* getToken0
	*
	*/ _proto["getToken0"] = function getToken0(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::getToken0", [], __options, __signerOptions);
    };
    /**
	* price1CumulativeLast
	*
	*/ _proto["price1CumulativeLast"] = function price1CumulativeLast(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::price1CumulativeLast", [], __options, __signerOptions);
    };
    /**
	* kLast
	*
	*/ _proto["kLast"] = function kLast(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::kLast", [], __options, __signerOptions);
    };
    /**
	* factory
	*
	*/ _proto["factory"] = function factory(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::factory", [], __options, __signerOptions);
    };
    /**
	* getReserves
	*
	*/ _proto["getReserves"] = function getReserves(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::getReserves", [], __options, __signerOptions);
    };
    /**
	* burn
	*
	* @param { ArgumentTypes.AccountId } to,
	*/ _proto["burn"] = function burn(to, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::burn", [
            to
        ], __options, __signerOptions);
    };
    /**
	* getToken1
	*
	*/ _proto["getToken1"] = function getToken1(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::getToken1", [], __options, __signerOptions);
    };
    /**
	* initialize
	*
	* @param { ArgumentTypes.AccountId } token0,
	* @param { ArgumentTypes.AccountId } token1,
	*/ _proto["initialize"] = function initialize(token0, token1, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::initialize", [
            token0,
            token1
        ], __options, __signerOptions);
    };
    /**
	* mint
	*
	* @param { ArgumentTypes.AccountId } to,
	*/ _proto["mint"] = function mint(to, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::mint", [
            to
        ], __options, __signerOptions);
    };
    /**
	* skim
	*
	* @param { ArgumentTypes.AccountId } to,
	*/ _proto["skim"] = function skim(to, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::skim", [
            to
        ], __options, __signerOptions);
    };
    /**
	* sync
	*
	*/ _proto["sync"] = function sync(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::sync", [], __options, __signerOptions);
    };
    /**
	* price0CumulativeLast
	*
	*/ _proto["price0CumulativeLast"] = function price0CumulativeLast(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::price0CumulativeLast", [], __options, __signerOptions);
    };
    /**
	* swap
	*
	* @param { (string | number | BN) } amount0Out,
	* @param { (string | number | BN) } amount1Out,
	* @param { ArgumentTypes.AccountId } to,
	* @param { Array<(number | string | BN)> } data,
	*/ _proto["swap"] = function swap(amount0Out, amount1Out, to, data, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::swap", [
            amount0Out,
            amount1Out,
            to,
            data
        ], __options, __signerOptions);
    };
    return Methods;
}();


;// CONCATENATED MODULE: ./utils/types/mixed-methods/pair_contract.ts
/* This file is auto-generated */ 



var mixed_methods_pair_contract_Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(apiPromise, nativeContract, keyringPair) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__apiPromise = apiPromise;
        this.__nativeContract = nativeContract;
        this.__keyringPair = keyringPair;
        this.__callerAddress = keyringPair.address;
    }
    var _proto = Methods.prototype;
    /**
	* totalSupply
	*
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["totalSupply"] = function totalSupply(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::totalSupply", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[12]);
        });
    };
    /**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { void }
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["balanceOf"] = function balanceOf(owner, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::balanceOf", [
            owner
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[12]);
        });
    };
    /**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { void }
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options);
    };
    /**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["allowance"] = function allowance(owner, spender, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::allowance", [
            owner,
            spender
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[12]);
        });
    };
    /**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { void }
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { void }
	*/ _proto["transfer"] = function transfer(to, value, data, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transfer", [
            to,
            value,
            data
        ], __options);
    };
    /**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	* @returns { void }
	*/ _proto["approve"] = function approve(spender, value, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::approve", [
            spender,
            value
        ], __options);
    };
    /**
	* tokenSymbol
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenSymbol", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[16]);
        });
    };
    /**
	* tokenDecimals
	*
	* @returns { Result<number, ReturnTypes.LangError> }
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenDecimals", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[18]);
        });
    };
    /**
	* tokenName
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenName"] = function tokenName(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenName", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[16]);
        });
    };
    /**
	* owner
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["owner"] = function owner(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "ownable::owner", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* renounceOwnership
	*
	* @returns { void }
	*/ _proto["renounceOwnership"] = function renounceOwnership(__options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::renounceOwnership", [], __options);
    };
    /**
	* transferOwnership
	*
	* @param { ArgumentTypes.AccountId } newOwner,
	* @returns { void }
	*/ _proto["transferOwnership"] = function transferOwnership(newOwner, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "ownable::transferOwnership", [
            newOwner
        ], __options);
    };
    /**
	* getToken0
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["getToken0"] = function getToken0(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::getToken0", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* price1CumulativeLast
	*
	* @returns { Result<ReturnTypes.WrappedU256, ReturnTypes.LangError> }
	*/ _proto["price1CumulativeLast"] = function price1CumulativeLast(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::price1CumulativeLast", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[23]);
        });
    };
    /**
	* kLast
	*
	* @returns { Result<ReturnTypes.WrappedU256, ReturnTypes.LangError> }
	*/ _proto["kLast"] = function kLast(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::kLast", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[23]);
        });
    };
    /**
	* factory
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["factory"] = function factory(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::factory", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* getReserves
	*
	* @returns { Result<[ReturnNumber, ReturnNumber, number], ReturnTypes.LangError> }
	*/ _proto["getReserves"] = function getReserves(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::getReserves", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[24]);
        });
    };
    /**
	* burn
	*
	* @param { ArgumentTypes.AccountId } to,
	* @returns { void }
	*/ _proto["burn"] = function burn(to, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::burn", [
            to
        ], __options);
    };
    /**
	* getToken1
	*
	* @returns { Result<ReturnTypes.AccountId, ReturnTypes.LangError> }
	*/ _proto["getToken1"] = function getToken1(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::getToken1", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[19]);
        });
    };
    /**
	* initialize
	*
	* @param { ArgumentTypes.AccountId } token0,
	* @param { ArgumentTypes.AccountId } token1,
	* @returns { void }
	*/ _proto["initialize"] = function initialize(token0, token1, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::initialize", [
            token0,
            token1
        ], __options);
    };
    /**
	* mint
	*
	* @param { ArgumentTypes.AccountId } to,
	* @returns { void }
	*/ _proto["mint"] = function mint(to, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::mint", [
            to
        ], __options);
    };
    /**
	* skim
	*
	* @param { ArgumentTypes.AccountId } to,
	* @returns { void }
	*/ _proto["skim"] = function skim(to, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::skim", [
            to
        ], __options);
    };
    /**
	* sync
	*
	* @returns { void }
	*/ _proto["sync"] = function sync(__options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::sync", [], __options);
    };
    /**
	* price0CumulativeLast
	*
	* @returns { Result<ReturnTypes.WrappedU256, ReturnTypes.LangError> }
	*/ _proto["price0CumulativeLast"] = function price0CumulativeLast(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "pair::price0CumulativeLast", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_pair_contract_namespaceObject[23]);
        });
    };
    /**
	* swap
	*
	* @param { (string | number | BN) } amount0Out,
	* @param { (string | number | BN) } amount1Out,
	* @param { ArgumentTypes.AccountId } to,
	* @param { Array<(number | string | BN)> } data,
	* @returns { void }
	*/ _proto["swap"] = function swap(amount0Out, amount1Out, to, data, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "pair::swap", [
            amount0Out,
            amount1Out,
            to,
            data
        ], __options);
    };
    return Methods;
}();


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(21157);
;// CONCATENATED MODULE: ./utils/types/event-data/pair_contract.json
var event_data_pair_contract_namespaceObject = JSON.parse('{"y1":{"name":"Mint","body":{"sender":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"amount0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"amount1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"g_":{"name":"Burn","body":{"sender":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"amount0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"amount1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"to":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"HY":{"name":"Swap","body":{"sender":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"amount0In":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"amount1In":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"amount0Out":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"amount1Out":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"to":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"fo":{"name":"Sync","body":{"reserve0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"reserve1":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"FE":{"name":"Transfer","body":{"from":{"name":"Option","body":{"0":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"to":{"name":"Option","body":{"0":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"value":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"_":{"name":"Approval","body":{"owner":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"spender":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"value":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false}}');
;// CONCATENATED MODULE: ./utils/types/events/pair_contract.ts





var EventsClass = /*#__PURE__*/ function() {
    "use strict";
    function EventsClass(nativeContract, api) {
        (0,_class_call_check/* default */.Z)(this, EventsClass);
        this.__nativeContract = nativeContract;
        this.__api = api;
    }
    var _proto = EventsClass.prototype;
    _proto.subscribeOnMintEvent = function subscribeOnMintEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_pair_contract_namespaceObject.y1));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Mint";
        });
    };
    _proto.subscribeOnBurnEvent = function subscribeOnBurnEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_pair_contract_namespaceObject.g_));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Burn";
        });
    };
    _proto.subscribeOnSwapEvent = function subscribeOnSwapEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_pair_contract_namespaceObject.HY));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Swap";
        });
    };
    _proto.subscribeOnSyncEvent = function subscribeOnSyncEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_pair_contract_namespaceObject.fo));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Sync";
        });
    };
    _proto.subscribeOnTransferEvent = function subscribeOnTransferEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_pair_contract_namespaceObject.FE));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Transfer";
        });
    };
    _proto.subscribeOnApprovalEvent = function subscribeOnApprovalEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_pair_contract_namespaceObject._));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Approval";
        });
    };
    _proto.__subscribeOnEvent = function __subscribeOnEvent(callback) {
        var filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
            return true;
        };
        var _this = this;
        // @ts-ignore
        return this.__api.query.system.events(function(events) {
            events.forEach(function(record) {
                var event = record.event;
                if (event.method == "ContractEmitted") {
                    var _data = (0,_sliced_to_array/* default */.Z)(record.event.data, 2), address = _data[0], data = _data[1];
                    if (address.toString() === _this.__nativeContract.address.toString()) {
                        var ref = _this.__nativeContract.abi.decodeEvent(data), args = ref.args, event1 = ref.event;
                        if (filter(event1.identifier.toString())) callback(args, event1);
                    }
                }
            });
        });
    };
    return EventsClass;
}();


;// CONCATENATED MODULE: ./utils/types/contracts/pair_contract.ts
/* This file is auto-generated */ 









var Contract = /*#__PURE__*/ function() {
    "use strict";
    function Contract(address, signer, nativeAPI) {
        (0,_class_call_check/* default */.Z)(this, Contract);
        this.address = address;
        this.nativeContract = new promise/* ContractPromise */.vM(nativeAPI, pair_contract_namespaceObject, address);
        this.nativeAPI = nativeAPI;
        this.signer = signer;
        this.contractAbi = new Abi/* Abi */.P(pair_contract_namespaceObject);
        this.query = new Methods(this.nativeContract, this.nativeAPI, signer.address);
        this.buildExtrinsic = new pair_contract_Methods(this.nativeContract, this.nativeAPI);
        this.tx = new tx_sign_and_send_pair_contract_Methods(nativeAPI, this.nativeContract, signer);
        this.methods = new mixed_methods_pair_contract_Methods(nativeAPI, this.nativeContract, signer);
        this.events = new EventsClass(this.nativeContract, nativeAPI);
    }
    var _proto = Contract.prototype;
    /**
	 * withSigner
	 *
	 * @param signer - The signer to use for signing transactions.
	 * @returns New instance of the contract class with new signer.
	 * @example
	 * ```typescript
	 * const contract = new Contract(address, signerAlice, api);
	 * await contract.mint(signerBob.address, 100);
	 * await contract.withSigner(signerBob).transfer(signerAlice.address, 100);
	 * ```
	*/ _proto.withSigner = function withSigner(signer) {
        return new Contract(this.address, signer, this.nativeAPI);
    };
    /**
	* withAddress
	*
	* @param address - The address of the contract.
	* @returns New instance of the contract class to interact with new contract.
	*/ _proto.withAddress = function withAddress(address) {
        return new Contract(address, this.signer, this.nativeAPI);
    };
    /**
	 * withAPI
	 *
	 * @param api - The API instance to use for queries.
	 * @returns New instance of the contract class to interact with new API.
	*/ _proto.withAPI = function withAPI(api) {
        return new Contract(this.address, this.signer, api);
    };
    (0,_create_class/* default */.Z)(Contract, [
        {
            key: "name",
            get: /**
	 * name
	 *
	 * @returns The name of the contract.
	*/ function get() {
                return this.nativeContract.abi.info.contract.name.toString();
            }
        },
        {
            key: "abi",
            get: /**
	 * abi
	 *
	 * @returns The abi of the contract.
	*/ function get() {
                return this.contractAbi;
            }
        }
    ]);
    return Contract;
}();



/***/ }),

/***/ 69253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Contract; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(62139);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(49573);
// EXTERNAL MODULE: ./node_modules/@polkadot/api-contract/Abi/index.js + 6 modules
var Abi = __webpack_require__(85220);
// EXTERNAL MODULE: ./node_modules/@polkadot/api-contract/promise/index.js + 4 modules
var promise = __webpack_require__(64760);
;// CONCATENATED MODULE: ./utils/artifacts/psp22_token.json
var psp22_token_namespaceObject = JSON.parse('{"source":{"hash":"0xe2195e10528631df7a85490fd2873a240785e5b2190f943a9650fb56f9ada49b","language":"ink! 4.0.1","compiler":"rustc 1.68.0-nightly","build_info":{"build_mode":"Release","cargo_contract_version":"2.0.2","rust_toolchain":"nightly-aarch64-apple-darwin","wasm_opt_settings":{"keep_debug_symbols":false,"optimization_passes":"Z"}}},"contract":{"name":"psp22_token","version":"2.1.0","authors":["Supercolony <green.baneling@supercolony.net>"]},"spec":{"constructors":[{"args":[{"label":"total_supply","type":{"displayName":["Balance"],"type":0}},{"label":"name","type":{"displayName":["Option"],"type":4}},{"label":"symbol","type":{"displayName":["Option"],"type":4}},{"label":"decimals","type":{"displayName":["u8"],"type":3}}],"docs":[],"label":"new","payable":false,"returnType":{"displayName":["ink_primitives","ConstructorResult"],"type":5},"selector":"0x9bae9d5e"}],"docs":[],"events":[{"args":[{"docs":[],"indexed":true,"label":"from","type":{"displayName":["Option"],"type":15}},{"docs":[],"indexed":true,"label":"to","type":{"displayName":["Option"],"type":15}},{"docs":[],"indexed":false,"label":"value","type":{"displayName":["Balance"],"type":0}}],"docs":[],"label":"Transfer"},{"args":[{"docs":[],"indexed":true,"label":"owner","type":{"displayName":["AccountId"],"type":7}},{"docs":[],"indexed":true,"label":"spender","type":{"displayName":["AccountId"],"type":7}},{"docs":[],"indexed":false,"label":"value","type":{"displayName":["Balance"],"type":0}}],"docs":[],"label":"Approval"}],"lang_error":{"displayName":["ink","LangError"],"type":6},"messages":[{"args":[{"label":"account","type":{"displayName":["AccountId"],"type":7}},{"label":"amount","type":{"displayName":["Balance"],"type":0}}],"docs":[" Permissionless mint, test purpose only. DO NOT use for production."," Users can test our uniswap v2 demo on Shibuya by minting it by themselves."],"label":"mint","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":9},"selector":"0xcfdd9aa2"},{"args":[{"label":"owner","type":{"displayName":["psp22_external","AllowanceInput1"],"type":7}},{"label":"spender","type":{"displayName":["psp22_external","AllowanceInput2"],"type":7}}],"docs":[" Returns the amount which `spender` is still allowed to withdraw from `owner`.",""," Returns `0` if no allowance has been set `0`."],"label":"PSP22::allowance","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":12},"selector":"0x4d47d921"},{"args":[],"docs":[" Returns the total token supply."],"label":"PSP22::total_supply","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":12},"selector":"0x162df8c2"},{"args":[{"label":"to","type":{"displayName":["psp22_external","TransferInput1"],"type":7}},{"label":"value","type":{"displayName":["psp22_external","TransferInput2"],"type":0}},{"label":"data","type":{"displayName":["psp22_external","TransferInput3"],"type":2}}],"docs":[" Transfers `value` amount of tokens from the caller\'s account to account `to`"," with additional `data` in unspecified format.",""," On success a `Transfer` event is emitted.",""," # Errors",""," Returns `InsufficientBalance` error if there are not enough tokens on"," the caller\'s account Balance.",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::transfer","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":9},"selector":"0xdb20f9f5"},{"args":[{"label":"spender","type":{"displayName":["psp22_external","IncreaseAllowanceInput1"],"type":7}},{"label":"delta_value","type":{"displayName":["psp22_external","IncreaseAllowanceInput2"],"type":0}}],"docs":[" Atomically increases the allowance granted to `spender` by the caller.",""," An `Approval` event is emitted.",""," # Errors",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::increase_allowance","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":9},"selector":"0x96d6b57a"},{"args":[{"label":"from","type":{"displayName":["psp22_external","TransferFromInput1"],"type":7}},{"label":"to","type":{"displayName":["psp22_external","TransferFromInput2"],"type":7}},{"label":"value","type":{"displayName":["psp22_external","TransferFromInput3"],"type":0}},{"label":"data","type":{"displayName":["psp22_external","TransferFromInput4"],"type":2}}],"docs":[" Transfers `value` tokens on the behalf of `from` to the account `to`"," with additional `data` in unspecified format.",""," This can be used to allow a contract to transfer tokens on ones behalf and/or"," to charge fees in sub-currencies, for example.",""," On success a `Transfer` and `Approval` events are emitted.",""," # Errors",""," Returns `InsufficientAllowance` error if there are not enough tokens allowed"," for the caller to withdraw from `from`.",""," Returns `InsufficientBalance` error if there are not enough tokens on"," the the account Balance of `from`.",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::transfer_from","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":9},"selector":"0x54b3c76e"},{"args":[{"label":"spender","type":{"displayName":["psp22_external","ApproveInput1"],"type":7}},{"label":"value","type":{"displayName":["psp22_external","ApproveInput2"],"type":0}}],"docs":[" Allows `spender` to withdraw from the caller\'s account multiple times, up to"," the `value` amount.",""," If this function is called again it overwrites the current allowance with `value`.",""," An `Approval` event is emitted.",""," # Errors",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::approve","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":9},"selector":"0xb20f1bbd"},{"args":[{"label":"owner","type":{"displayName":["psp22_external","BalanceOfInput1"],"type":7}}],"docs":[" Returns the account Balance for the specified `owner`.",""," Returns `0` if the account is non-existent."],"label":"PSP22::balance_of","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":12},"selector":"0x6568382f"},{"args":[{"label":"spender","type":{"displayName":["psp22_external","DecreaseAllowanceInput1"],"type":7}},{"label":"delta_value","type":{"displayName":["psp22_external","DecreaseAllowanceInput2"],"type":0}}],"docs":[" Atomically decreases the allowance granted to `spender` by the caller.",""," An `Approval` event is emitted.",""," # Errors",""," Returns `InsufficientAllowance` error if there are not enough tokens allowed"," by owner for `spender`.",""," Returns `ZeroSenderAddress` error if sender\'s address is zero.",""," Returns `ZeroRecipientAddress` error if recipient\'s address is zero."],"label":"PSP22::decrease_allowance","mutates":true,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":9},"selector":"0xfecb57d5"},{"args":[],"docs":[" Returns the token symbol."],"label":"PSP22Metadata::token_symbol","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0x34205be5"},{"args":[],"docs":[" Returns the token name."],"label":"PSP22Metadata::token_name","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":13},"selector":"0x3d261bd4"},{"args":[],"docs":[" Returns the token decimals."],"label":"PSP22Metadata::token_decimals","mutates":false,"payable":false,"returnType":{"displayName":["ink","MessageResult"],"type":14},"selector":"0x7271b782"}]},"storage":{"root":{"layout":{"struct":{"fields":[{"layout":{"struct":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":0}},"name":"supply"},{"layout":{"root":{"layout":{"leaf":{"key":"0x1d458d3b","ty":0}},"root_key":"0x1d458d3b"}},"name":"balances"},{"layout":{"root":{"layout":{"leaf":{"key":"0x0abd72fb","ty":0}},"root_key":"0x0abd72fb"}},"name":"allowances"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":1}},"name":"0"}],"name":"Some"}}}},"name":"_reserved"}],"name":"Data"}},"name":"psp22"},{"layout":{"struct":{"fields":[{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":2}},"name":"0"}],"name":"Some"}}}},"name":"name"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":2}},"name":"0"}],"name":"Some"}}}},"name":"symbol"},{"layout":{"leaf":{"key":"0x00000000","ty":3}},"name":"decimals"},{"layout":{"enum":{"dispatchKey":"0x00000000","name":"Option","variants":{"0":{"fields":[],"name":"None"},"1":{"fields":[{"layout":{"leaf":{"key":"0x00000000","ty":1}},"name":"0"}],"name":"Some"}}}},"name":"_reserved"}],"name":"Data"}},"name":"metadata"}],"name":"MyPSP22"}},"root_key":"0x00000000"}},"types":[{"id":0,"type":{"def":{"primitive":"u128"}}},{"id":1,"type":{"def":{"tuple":[]}}},{"id":2,"type":{"def":{"sequence":{"type":3}}}},{"id":3,"type":{"def":{"primitive":"u8"}}},{"id":4,"type":{"def":{"variant":{"variants":[{"index":0,"name":"None"},{"fields":[{"type":2}],"index":1,"name":"Some"}]}},"params":[{"name":"T","type":2}],"path":["Option"]}},{"id":5,"type":{"def":{"variant":{"variants":[{"fields":[{"type":1}],"index":0,"name":"Ok"},{"fields":[{"type":6}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":1},{"name":"E","type":6}],"path":["Result"]}},{"id":6,"type":{"def":{"variant":{"variants":[{"index":1,"name":"CouldNotReadInput"}]}},"path":["ink_primitives","LangError"]}},{"id":7,"type":{"def":{"composite":{"fields":[{"type":8,"typeName":"[u8; 32]"}]}},"path":["ink_primitives","types","AccountId"]}},{"id":8,"type":{"def":{"array":{"len":32,"type":3}}}},{"id":9,"type":{"def":{"variant":{"variants":[{"fields":[{"type":10}],"index":0,"name":"Ok"},{"fields":[{"type":6}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":10},{"name":"E","type":6}],"path":["Result"]}},{"id":10,"type":{"def":{"variant":{"variants":[{"fields":[{"type":1}],"index":0,"name":"Ok"},{"fields":[{"type":11}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":1},{"name":"E","type":11}],"path":["Result"]}},{"id":11,"type":{"def":{"variant":{"variants":[{"fields":[{"type":2,"typeName":"String"}],"index":0,"name":"Custom"},{"index":1,"name":"InsufficientBalance"},{"index":2,"name":"InsufficientAllowance"},{"index":3,"name":"ZeroRecipientAddress"},{"index":4,"name":"ZeroSenderAddress"},{"fields":[{"type":2,"typeName":"String"}],"index":5,"name":"SafeTransferCheckFailed"}]}},"path":["openbrush_contracts","traits","errors","psp22","PSP22Error"]}},{"id":12,"type":{"def":{"variant":{"variants":[{"fields":[{"type":0}],"index":0,"name":"Ok"},{"fields":[{"type":6}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":0},{"name":"E","type":6}],"path":["Result"]}},{"id":13,"type":{"def":{"variant":{"variants":[{"fields":[{"type":4}],"index":0,"name":"Ok"},{"fields":[{"type":6}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":4},{"name":"E","type":6}],"path":["Result"]}},{"id":14,"type":{"def":{"variant":{"variants":[{"fields":[{"type":3}],"index":0,"name":"Ok"},{"fields":[{"type":6}],"index":1,"name":"Err"}]}},"params":[{"name":"T","type":3},{"name":"E","type":6}],"path":["Result"]}},{"id":15,"type":{"def":{"variant":{"variants":[{"index":0,"name":"None"},{"fields":[{"type":7}],"index":1,"name":"Some"}]}},"params":[{"name":"T","type":7}],"path":["Option"]}}],"version":"4"}');
// EXTERNAL MODULE: ./node_modules/@arthswap/typechain-types/dist/index.js
var dist = __webpack_require__(41827);
;// CONCATENATED MODULE: ./utils/types/data/psp22_token.json
var data_psp22_token_namespaceObject = JSON.parse('{"0":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"2":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"3":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false},"4":{"name":"Option","body":{"0":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"6":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false},"7":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"8":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"9":{"name":"Result<Result<null, PSP22Error, LangError","body":{"ok":{"name":"Result<null, PSP22Error","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"10":{"name":"Result<null, PSP22Error","body":{"ok":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"11":{"name":"PSP22Error","body":{"custom":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"insufficientBalance":null,"insufficientAllowance":null,"zeroRecipientAddress":null,"zeroSenderAddress":null,"safeTransferCheckFailed":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"12":{"name":"Result<ReturnNumber, LangError","body":{"ok":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"13":{"name":"Result<Option, LangError","body":{"ok":{"name":"Option","body":{"0":{"name":"Array","body":{"0":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"14":{"name":"Result<number, LangError","body":{"ok":{"name":"number","isResult":false,"isPrimitive":true,"isConvertable":false},"err":{"name":"LangError","body":{"CouldNotReadInput":null},"isResult":false,"isPrimitive":false,"isConvertable":false}},"isResult":true,"isPrimitive":false,"isConvertable":false},"15":{"name":"Option","body":{"0":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false}}');
;// CONCATENATED MODULE: ./utils/types/query/psp22_token.ts
/* This file is auto-generated */ 



var Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(nativeContract, nativeApi, callerAddress) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__nativeContract = nativeContract;
        this.__callerAddress = callerAddress;
        this.__apiPromise = nativeApi;
    }
    var _proto = Methods.prototype;
    /**
	* mint
	*
	* @param { ArgumentTypes.AccountId } account,
	* @param { (string | number | BN) } amount,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["mint"] = function mint(account, amount, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "mint", [
            account,
            amount
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[9]);
        });
    };
    /**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["allowance"] = function allowance(owner, spender, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::allowance", [
            owner,
            spender
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[12]);
        });
    };
    /**
	* totalSupply
	*
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["totalSupply"] = function totalSupply(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::totalSupply", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[12]);
        });
    };
    /**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["transfer"] = function transfer(to, value, data, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::transfer", [
            to,
            value,
            data
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[9]);
        });
    };
    /**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[9]);
        });
    };
    /**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[9]);
        });
    };
    /**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["approve"] = function approve(spender, value, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::approve", [
            spender,
            value
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[9]);
        });
    };
    /**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["balanceOf"] = function balanceOf(owner, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::balanceOf", [
            owner
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[12]);
        });
    };
    /**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { Result<Result<null, ReturnTypes.PSP22Error>, ReturnTypes.LangError> }
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[9]);
        });
    };
    /**
	* tokenSymbol
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenSymbol", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[13]);
        });
    };
    /**
	* tokenName
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenName"] = function tokenName(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenName", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[13]);
        });
    };
    /**
	* tokenDecimals
	*
	* @returns { Result<number, ReturnTypes.LangError> }
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenDecimals", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[14]);
        });
    };
    return Methods;
}();


;// CONCATENATED MODULE: ./utils/types/build-extrinsic/psp22_token.ts
/* This file is auto-generated */ 

var psp22_token_Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(nativeContract, apiPromise) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__nativeContract = nativeContract;
        this.__apiPromise = apiPromise;
    }
    var _proto = Methods.prototype;
    /**
	 * mint
	 *
	 * @param { ArgumentTypes.AccountId } account,
	 * @param { (string | number | BN) } amount,
	*/ _proto["mint"] = function mint(account, amount, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "mint", [
            account,
            amount
        ], __options);
    };
    /**
	 * allowance
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	 * @param { ArgumentTypes.AccountId } spender,
	*/ _proto["allowance"] = function allowance(owner, spender, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::allowance", [
            owner,
            spender
        ], __options);
    };
    /**
	 * totalSupply
	 *
	*/ _proto["totalSupply"] = function totalSupply(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::totalSupply", [], __options);
    };
    /**
	 * transfer
	 *
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	*/ _proto["transfer"] = function transfer(to, value, data, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::transfer", [
            to,
            value,
            data
        ], __options);
    };
    /**
	 * increaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	 * transferFrom
	 *
	 * @param { ArgumentTypes.AccountId } from,
	 * @param { ArgumentTypes.AccountId } to,
	 * @param { (string | number | BN) } value,
	 * @param { Array<(number | string | BN)> } data,
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options);
    };
    /**
	 * approve
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } value,
	*/ _proto["approve"] = function approve(spender, value, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::approve", [
            spender,
            value
        ], __options);
    };
    /**
	 * balanceOf
	 *
	 * @param { ArgumentTypes.AccountId } owner,
	*/ _proto["balanceOf"] = function balanceOf(owner, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::balanceOf", [
            owner
        ], __options);
    };
    /**
	 * decreaseAllowance
	 *
	 * @param { ArgumentTypes.AccountId } spender,
	 * @param { (string | number | BN) } deltaValue,
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	 * tokenSymbol
	 *
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22Metadata::tokenSymbol", [], __options);
    };
    /**
	 * tokenName
	 *
	*/ _proto["tokenName"] = function tokenName(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22Metadata::tokenName", [], __options);
    };
    /**
	 * tokenDecimals
	 *
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options) {
        return (0,dist.buildSubmittableExtrinsic)(this.__apiPromise, this.__nativeContract, "psp22Metadata::tokenDecimals", [], __options);
    };
    return Methods;
}();


;// CONCATENATED MODULE: ./utils/types/tx-sign-and-send/psp22_token.ts
/* This file is auto-generated */ 

var tx_sign_and_send_psp22_token_Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(apiPromise, nativeContract, keyringPair) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__apiPromise = apiPromise;
        this.__nativeContract = nativeContract;
        this.__keyringPair = keyringPair;
    }
    var _proto = Methods.prototype;
    /**
	* mint
	*
	* @param { ArgumentTypes.AccountId } account,
	* @param { (string | number | BN) } amount,
	*/ _proto["mint"] = function mint(account, amount, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "mint", [
            account,
            amount
        ], __options, __signerOptions);
    };
    /**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	*/ _proto["allowance"] = function allowance(owner, spender, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::allowance", [
            owner,
            spender
        ], __options, __signerOptions);
    };
    /**
	* totalSupply
	*
	*/ _proto["totalSupply"] = function totalSupply(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::totalSupply", [], __options, __signerOptions);
    };
    /**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	*/ _proto["transfer"] = function transfer(to, value, data, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transfer", [
            to,
            value,
            data
        ], __options, __signerOptions);
    };
    /**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options, __signerOptions);
    };
    /**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options, __signerOptions);
    };
    /**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	*/ _proto["approve"] = function approve(spender, value, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::approve", [
            spender,
            value
        ], __options, __signerOptions);
    };
    /**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	*/ _proto["balanceOf"] = function balanceOf(owner, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::balanceOf", [
            owner
        ], __options, __signerOptions);
    };
    /**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options, __signerOptions);
    };
    /**
	* tokenSymbol
	*
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenSymbol", [], __options, __signerOptions);
    };
    /**
	* tokenName
	*
	*/ _proto["tokenName"] = function tokenName(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenName", [], __options, __signerOptions);
    };
    /**
	* tokenDecimals
	*
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options, __signerOptions) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22Metadata::tokenDecimals", [], __options, __signerOptions);
    };
    return Methods;
}();


;// CONCATENATED MODULE: ./utils/types/mixed-methods/psp22_token.ts
/* This file is auto-generated */ 



var mixed_methods_psp22_token_Methods = /*#__PURE__*/ function() {
    "use strict";
    function Methods(apiPromise, nativeContract, keyringPair) {
        (0,_class_call_check/* default */.Z)(this, Methods);
        this.__apiPromise = apiPromise;
        this.__nativeContract = nativeContract;
        this.__keyringPair = keyringPair;
        this.__callerAddress = keyringPair.address;
    }
    var _proto = Methods.prototype;
    /**
	* mint
	*
	* @param { ArgumentTypes.AccountId } account,
	* @param { (string | number | BN) } amount,
	* @returns { void }
	*/ _proto["mint"] = function mint(account, amount, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "mint", [
            account,
            amount
        ], __options);
    };
    /**
	* allowance
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @param { ArgumentTypes.AccountId } spender,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["allowance"] = function allowance(owner, spender, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::allowance", [
            owner,
            spender
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[12]);
        });
    };
    /**
	* totalSupply
	*
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["totalSupply"] = function totalSupply(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::totalSupply", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[12]);
        });
    };
    /**
	* transfer
	*
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { void }
	*/ _proto["transfer"] = function transfer(to, value, data, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transfer", [
            to,
            value,
            data
        ], __options);
    };
    /**
	* increaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { void }
	*/ _proto["increaseAllowance"] = function increaseAllowance(spender, deltaValue, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::increaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	* transferFrom
	*
	* @param { ArgumentTypes.AccountId } from,
	* @param { ArgumentTypes.AccountId } to,
	* @param { (string | number | BN) } value,
	* @param { Array<(number | string | BN)> } data,
	* @returns { void }
	*/ _proto["transferFrom"] = function transferFrom(from, to, value, data, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::transferFrom", [
            from,
            to,
            value,
            data
        ], __options);
    };
    /**
	* approve
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } value,
	* @returns { void }
	*/ _proto["approve"] = function approve(spender, value, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::approve", [
            spender,
            value
        ], __options);
    };
    /**
	* balanceOf
	*
	* @param { ArgumentTypes.AccountId } owner,
	* @returns { Result<ReturnNumber, ReturnTypes.LangError> }
	*/ _proto["balanceOf"] = function balanceOf(owner, __options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22::balanceOf", [
            owner
        ], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[12]);
        });
    };
    /**
	* decreaseAllowance
	*
	* @param { ArgumentTypes.AccountId } spender,
	* @param { (string | number | BN) } deltaValue,
	* @returns { void }
	*/ _proto["decreaseAllowance"] = function decreaseAllowance(spender, deltaValue, __options) {
        return (0,dist.txSignAndSend)(this.__apiPromise, this.__nativeContract, this.__keyringPair, "psp22::decreaseAllowance", [
            spender,
            deltaValue
        ], __options);
    };
    /**
	* tokenSymbol
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenSymbol"] = function tokenSymbol(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenSymbol", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[13]);
        });
    };
    /**
	* tokenName
	*
	* @returns { Result<Array<number> | null, ReturnTypes.LangError> }
	*/ _proto["tokenName"] = function tokenName(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenName", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[13]);
        });
    };
    /**
	* tokenDecimals
	*
	* @returns { Result<number, ReturnTypes.LangError> }
	*/ _proto["tokenDecimals"] = function tokenDecimals(__options) {
        return (0,dist.queryOkJSON)(this.__apiPromise, this.__nativeContract, this.__callerAddress, "psp22Metadata::tokenDecimals", [], __options, function(result) {
            return (0,dist.handleReturnType)(result, data_psp22_token_namespaceObject[14]);
        });
    };
    return Methods;
}();


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(21157);
;// CONCATENATED MODULE: ./utils/types/event-data/psp22_token.json
var event_data_psp22_token_namespaceObject = JSON.parse('{"F":{"name":"Transfer","body":{"from":{"name":"Option","body":{"0":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"to":{"name":"Option","body":{"0":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"1":{"name":"null","isResult":false,"isPrimitive":true,"isConvertable":false}},"isResult":false,"isPrimitive":false,"isConvertable":false},"value":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false},"_":{"name":"Approval","body":{"owner":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"spender":{"name":"AccountId","body":"string | number[]","isResult":false,"isPrimitive":true,"isConvertable":false},"value":{"name":"ReturnNumber","isResult":false,"isPrimitive":false,"isConvertable":true}},"isResult":false,"isPrimitive":false,"isConvertable":false}}');
;// CONCATENATED MODULE: ./utils/types/events/psp22_token.ts





var EventsClass = /*#__PURE__*/ function() {
    "use strict";
    function EventsClass(nativeContract, api) {
        (0,_class_call_check/* default */.Z)(this, EventsClass);
        this.__nativeContract = nativeContract;
        this.__api = api;
    }
    var _proto = EventsClass.prototype;
    _proto.subscribeOnTransferEvent = function subscribeOnTransferEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_psp22_token_namespaceObject.F));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Transfer";
        });
    };
    _proto.subscribeOnApprovalEvent = function subscribeOnApprovalEvent(callback) {
        var callbackWrapper = function(args, event) {
            var _event = {};
            for(var i = 0; i < args.length; i++){
                _event[event.args[i].name] = args[i].toJSON();
            }
            callback((0,dist.handleEventReturn)(_event, event_data_psp22_token_namespaceObject._));
        };
        return this.__subscribeOnEvent(callbackWrapper, function(eventName) {
            return eventName == "Approval";
        });
    };
    _proto.__subscribeOnEvent = function __subscribeOnEvent(callback) {
        var filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
            return true;
        };
        var _this = this;
        // @ts-ignore
        return this.__api.query.system.events(function(events) {
            events.forEach(function(record) {
                var event = record.event;
                if (event.method == "ContractEmitted") {
                    var _data = (0,_sliced_to_array/* default */.Z)(record.event.data, 2), address = _data[0], data = _data[1];
                    if (address.toString() === _this.__nativeContract.address.toString()) {
                        var ref = _this.__nativeContract.abi.decodeEvent(data), args = ref.args, event1 = ref.event;
                        if (filter(event1.identifier.toString())) callback(args, event1);
                    }
                }
            });
        });
    };
    return EventsClass;
}();


;// CONCATENATED MODULE: ./utils/types/contracts/psp22_token.ts
/* This file is auto-generated */ 









var Contract = /*#__PURE__*/ function() {
    "use strict";
    function Contract(address, signer, nativeAPI) {
        (0,_class_call_check/* default */.Z)(this, Contract);
        this.address = address;
        this.nativeContract = new promise/* ContractPromise */.vM(nativeAPI, psp22_token_namespaceObject, address);
        this.nativeAPI = nativeAPI;
        this.signer = signer;
        this.contractAbi = new Abi/* Abi */.P(psp22_token_namespaceObject);
        this.query = new Methods(this.nativeContract, this.nativeAPI, signer.address);
        this.buildExtrinsic = new psp22_token_Methods(this.nativeContract, this.nativeAPI);
        this.tx = new tx_sign_and_send_psp22_token_Methods(nativeAPI, this.nativeContract, signer);
        this.methods = new mixed_methods_psp22_token_Methods(nativeAPI, this.nativeContract, signer);
        this.events = new EventsClass(this.nativeContract, nativeAPI);
    }
    var _proto = Contract.prototype;
    /**
	 * withSigner
	 *
	 * @param signer - The signer to use for signing transactions.
	 * @returns New instance of the contract class with new signer.
	 * @example
	 * ```typescript
	 * const contract = new Contract(address, signerAlice, api);
	 * await contract.mint(signerBob.address, 100);
	 * await contract.withSigner(signerBob).transfer(signerAlice.address, 100);
	 * ```
	*/ _proto.withSigner = function withSigner(signer) {
        return new Contract(this.address, signer, this.nativeAPI);
    };
    /**
	* withAddress
	*
	* @param address - The address of the contract.
	* @returns New instance of the contract class to interact with new contract.
	*/ _proto.withAddress = function withAddress(address) {
        return new Contract(address, this.signer, this.nativeAPI);
    };
    /**
	 * withAPI
	 *
	 * @param api - The API instance to use for queries.
	 * @returns New instance of the contract class to interact with new API.
	*/ _proto.withAPI = function withAPI(api) {
        return new Contract(this.address, this.signer, api);
    };
    (0,_create_class/* default */.Z)(Contract, [
        {
            key: "name",
            get: /**
	 * name
	 *
	 * @returns The name of the contract.
	*/ function get() {
                return this.nativeContract.abi.info.contract.name.toString();
            }
        },
        {
            key: "abi",
            get: /**
	 * abi
	 *
	 * @returns The abi of the contract.
	*/ function get() {
                return this.contractAbi;
            }
        }
    ]);
    return Contract;
}();



/***/ }),

/***/ 69159:
/***/ (function() {

/* (ignored) */

/***/ })

}]);